window.FerobrillMeasurements={"reserve-300":{"id":"reserve-300","tab":"THE RESERVE 300","title":"THE RESERVE T-SHIRT","fit":"OVERSIZED FIT","intro":"An extended body, dropped shoulders and measured volume establish a relaxed oversized silhouette with balanced everyday proportion.","copy":"Designed with an oversized silhouette, dropped shoulders and a long, relaxed body for ease and architectural drape.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[53,71,50,22],[56,73,53,22.5],[59,75,56,23],[62,77,59,23.5],[65,79,62,24]]},"reserve-350":{"id":"reserve-350","tab":"THE RESERVE 350","title":"THE RESERVE T-SHIRT","fit":"OVERSIZED FIT","intro":"An extended body, dropped shoulders and substantial volume through the chest establish the intended oversized silhouette.","copy":"Designed with an oversized silhouette, dropped shoulders and a relaxed body. Select your usual size for the intended FEROBRILL fit, or size down for a closer silhouette.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[57,73,53,26],[59,75,54,26.5],[61,76.5,56,27],[63,78,57,27.5],[65,79.5,58,28]]},"reserve-400":{"id":"reserve-400","tab":"THE RESERVE 400","title":"THE RESERVE T-SHIRT","fit":"BOXY OVERSIZED FIT","intro":"A shortened body, extended shoulders and substantial width through the chest establish the intended boxy oversized silhouette.","copy":"Defined by substantial chest width, extended shoulders and a deliberately shortened body for a structured, boxy silhouette.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[61,65,57,22.5],[63,67,59,23],[65,69,61,23.5],[67,71,63,24],[69,73,65,24.5]]},"reserve-420-crop":{"id":"reserve-420-crop","tab":"THE RESERVE 420 CROP","title":"THE RESERVE CROP T-SHIRT","fit":"CROPPED OVERSIZED FIT","intro":"A compact body length, dropped shoulders and pronounced chest width create a cropped oversized silhouette with controlled structure.","copy":"Designed with a cropped oversized silhouette, broad chest and extended shoulders. Select your usual size for the intended architectural proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[61,62,57,25],[63,64,59,26],[65,66,61,27],[67,68,63,28],[69,70,65,29]]},"dexterous-340":{"id":"dexterous-340","tab":"THE DEXTEROUS 340","title":"THE DEXTEROUS WAFFLE T-SHIRT","fit":"RELAXED FIT","intro":"A straight extended body, dropped shoulders and measured chest volume establish a relaxed silhouette that accommodates the dimensional waffle structure.","copy":"Designed with a relaxed silhouette and dropped shoulders, allowing the waffle surface to retain ease without losing its composed line.","pos":3,"sizes":["S","M","L","XL","2XL"],"cm":[[57,70,56,21],[59,72,57.5,21.5],[61,74,59,22],[63,76,60.5,22.5],[65,78,62,23]]},"dexterous-340-waffle-t-shirt":{"id":"dexterous-340-waffle-t-shirt","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE RAGLAN T-SHIRT","fit":"RELAXED BOXY FIT","intro":"A compact body and raglan sleeve line establish a relaxed boxy silhouette.","copy":"Designed with measured volume and unrestricted movement.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[61,62,42],[63,64,44],[65,66,46],[67,68,48],[69,70,50]]},"dexterous-340-crop":{"id":"dexterous-340-crop","tab":"THE DEXTEROUS 340 CROP","title":"THE DEXTEROUS CROP WAFFLE BOXY T-SHIRT","fit":"CROPPED BOXY FIT","intro":"A shortened body, broad chest and extended shoulder line establish a compact boxy silhouette while preserving the waffle garment’s structural presence.","copy":"Designed with a cropped boxy silhouette, generous chest width and extended shoulders for deliberate proportion and textural clarity.","pos":3,"sizes":["S","M","L","XL","2XL"],"cm":[[61,62,57,25],[63,64,59,26],[65,66,61,27],[67,68,63,28],[69,70,65,29]]},"dexterous-340-waffle-long-sleeve-t-shirt":{"id":"dexterous-340-waffle-long-sleeve-t-shirt","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE LONG-SLEEVE T-SHIRT","fit":"RELAXED BOXY FIT","intro":"A compact body, broad chest and extended shoulder line establish a relaxed long-sleeve silhouette that preserves the waffle structure’s dimensional character.","copy":"Designed with a relaxed boxy silhouette, extended shoulders and measured sleeve length for composed everyday proportion.","pos":3,"sizes":["S","M","L","XL","2XL"],"cm":[[63,62,62,55],[65,64,64,56],[67,66,66,57],[69,68,68,58],[71,70,70,59]]},"dexterous-350-waffle-frame-t-shirt":{"id":"dexterous-350-waffle-frame-t-shirt","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE FRAME T-SHIRT","fit":"OVERSIZED BOXY FIT","intro":"A compact body, expansive chest and extended shoulder line establish an oversized boxy silhouette that gives the 350 GSM waffle surface room to hold its dimensional structure.","copy":"Designed with deliberate width through the chest, dropped shoulders and an extended elbow-length sleeve for the intended WAFFLE FRAME proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[61,61,59.5,35.5],[63,63,61.5,36.5],[65,65,63.5,37.5],[67,67,65.5,38.5],[69,69,67.5,39.5]]},"chancellor-350":{"id":"chancellor-350","tab":"THE CHANCELLOR 350","title":"THE CHANCELLOR T-SHIRT","fit":"BOXY OVERSIZED FIT","intro":"A compact body, broad shoulder line and substantial chest width create a boxy oversized silhouette with deliberate visual weight.","copy":"Designed with pronounced width, dropped shoulders and a shortened body for the intended structured, boxy FEROBRILL proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[61,65,57,22.5],[63,67,59,23],[65,69,61,23.5],[67,71,63,24],[69,73,65,24.5]]},"regent-275-t-shirt":{"id":"regent-275-t-shirt","collection":"THE REGENT","title":"THE REGENT BOXY T-SHIRT","fit":"RELAXED OVERSIZED FIT","intro":"An extended body, dropped shoulders and progressive chest volume create a relaxed oversized silhouette with a substantial, elongated drape.","copy":"Designed with an elongated relaxed body and dropped shoulders. Select your usual size for the intended volume, or size down for a closer proportion.","pos":4,"sizes":["S","M","L","XL","2XL","3XL"],"cm":[[56,71,50.5,20.5],[58,73,52,21.5],[60,75,53.5,22.5],[62,77,55,23.5],[64,79,56.5,24.5],[66,81,58,25.5]]},"regent-220-normcore-t-shirt":{"id":"regent-220-normcore-t-shirt","collection":"THE REGENT","title":"THE REGENT NORMCORE T-SHIRT","fit":"LOOSE H-LINE FIT","pos":3,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[51,68,47,21],[53.5,70,49,21.5],[56,72,51,22],[58.5,74,53,22.5],[61,76,55,23],[63.5,78,57,23.5]],"intro":"A loose H-line body, ribbed crewneck and short set-in sleeves establish a clean 220 GSM cotton–nylon silhouette.","copy":"Chest is a flat width. Compare the chest, body length, shoulder and sleeve measurements with a similar T-shirt you own."},"sovereign-sculpt-frame-tee":{"id":"sovereign-sculpt-frame-tee","collection":"THE SOVEREIGN","title":"THE SOVEREIGN SCULPT FRAME TEE","fit":"SCULPTED FIT","intro":"A close cropped body, U-shaped neckline and short set-in sleeves establish a compact sculpted silhouette.","copy":"Measurements are taken flat with the stretch fabric relaxed. Compare with a fitted stretch top you own.","pos":0,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[35,39.5,32,15],[37,40.5,33.5,16],[39,41.5,35,17],[41,42.5,36.5,18],[43,43.5,38,19]]},"sovereign-racer-top":{"id":"sovereign-racer-top","collection":"THE SOVEREIGN","title":"THE SOVEREIGN RACER TOP","fit":"SCULPTED RACER FIT","intro":"A close racer silhouette follows the upper body with measured support through the bust and underbust.","copy":"Compare the flat garment measurements with a fitted top you own before selecting your size.","pos":2,"sizes":["4","6","8","10","12"],"metrics":["LENGTH","BUST","UNDERBUST"],"cm":[[30.5,34,30.5],[31.5,36,32.5],[32.5,38,34.5],[33.5,40,36.5],[34.5,42,38.5]]},"sovereign-sculpt-square-neck":{"id":"sovereign-sculpt-square-neck","collection":"THE SOVEREIGN","title":"THE SOVEREIGN SCULPT SQUARE-NECK","fit":"SCULPTED LONGLINE FIT","intro":"A close longline body, square neckline and supportive underbust structure establish the intended sculpted silhouette.","copy":"Compare the flat bust and underbust measurements with a fitted top you own before selecting your size.","pos":2,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","BUST","UNDERBUST"],"cm":[[37.5,32,26],[38.5,34,28],[39.5,36,30],[40.5,38,32],[41.5,40,34]]},"chancellor-stripe-polo-dress":{"id":"chancellor-stripe-polo-dress","collection":"THE CHANCELLOR","title":"THE CHANCELLOR STRIPE POLO DRESS","fit":"LOOSE H-LINE FIT","intro":"A loose H-line body, collared neckline and short sleeves establish a straight polo-dress silhouette.","copy":"Compare the flat chest, full body length, shoulder and sleeve measurements with a similar polo dress you own.","pos":3,"sizes":["S","M","L"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[50,80,44,25],[52,82,46,26],[54,84,48,27]]},"chancellor-320-collared-pullover":{"id":"chancellor-320-collared-pullover","collection":"THE CHANCELLOR","title":"THE CHANCELLOR COLLARED PULLOVER","fit":"RELAXED BOXY FIT","intro":"A short body, broad chest and dropped shoulder line establish a compact boxy silhouette structured by an open lapel collar.","copy":"Designed with a relaxed boxy proportion, abbreviated length and controlled rib-knit boundaries. Compare the flat garment measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[58,46,54,57],[60,48,56,59],[62,50,58,61],[64,52,60,63],[66,54,62,65]]},"imperium-bastion-crewneck":{"id":"imperium-bastion-crewneck","collection":"THE IMPERIUM","title":"THE IMPERIUM BASTION CREWNECK","fit":"OVERSIZED H-LINE FIT","intro":"A broad straight body, extended shoulder line and measured sleeve length establish an oversized H-line silhouette with grounded structural presence.","copy":"Designed with substantial width through the chest, dropped shoulders and a clean vertical fall for the intended BASTION proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[66,66,57,63],[68,68,58.5,64],[70,70,60,65],[72,72,61.5,66],[74,74,63,67]]},"imperium-frame-crewneck":{"id":"imperium-frame-crewneck","collection":"THE IMPERIUM","title":"THE IMPERIUM FRAME CREWNECK","fit":"CROPPED OVERSIZED FIT","intro":"A compact body, broad chest and pronounced dropped shoulders establish a cropped oversized silhouette with dense architectural presence.","copy":"Designed with substantial width, an extended shoulder line and a shortened body for the intended structured FRAME proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[66,59,60,55],[68,61,62,56],[70,63,64,57],[72,65,66,58],[74,67,68,59]]},"imperium-heritage-crewneck":{"id":"imperium-heritage-crewneck","collection":"THE IMPERIUM","title":"THE IMPERIUM HERITAGE CREWNECK","fit":"LOOSE OVERSIZED FIT","intro":"A broad body, pronounced dropped shoulders and generous sleeve volume establish a loose oversized silhouette with substantial cotton weight.","copy":"Designed with an expansive torso, extended shoulder line and controlled rib-knit boundaries. Select your usual size for the intended HERITAGE proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[62,70,57,57],[64,72,59,58],[66,74,61,59],[68,76,63,60],[70,78,65,61]]},"reserve-360-crewneck":{"id":"reserve-360-crewneck","collection":"THE RESERVE","title":"THE RESERVE CREWNECK","fit":"BOXY OVERSIZED FIT","intro":"A compact body, broad chest and dropped shoulder line establish a structured boxy silhouette with the composed weight of substantial fleece.","copy":"Designed with a boxy oversized silhouette, pronounced chest width and dropped shoulders for deliberate architectural proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[66,60,60,55],[68,62,62,56],[70,64,64,57],[72,66,66,58],[74,68,68,59]]},"regent-400-crewneck":{"id":"regent-400-crewneck","collection":"THE REGENT","title":"THE REGENT CREWNECK","fit":"REGULAR FIT","intro":"A measured chest, balanced body length and regular sleeve construction establish a clean essential silhouette with controlled volume.","copy":"Designed with a regular silhouette and balanced proportions. Select your usual size for the intended composed FEROBRILL fit.","pos":2,"sizes":["S","M","L","XL","2XL"],"cm":[[57,65,null,60],[59,67,null,62],[61,69,null,64],[64,71,null,67],[67,74,null,70]]},"imperium-280-crop-vneck":{"id":"imperium-280-crop-vneck","collection":"THE IMPERIUM","title":"THE IMPERIUM CROP V-NECK","fit":"CROPPED RELAXED FIT","intro":"A shortened body, generous chest and dropped shoulder line create a relaxed cropped silhouette framed by a precise V-neckline.","copy":"Designed with a cropped relaxed silhouette, extended shoulders and controlled width through the chest for an intentional compact proportion.","pos":3,"sizes":["S","M","L","XL"],"cm":[[64,59,53,59],[66,61,54.5,60],[68,63,56,61],[70,65,57.5,62]]},"imperium-345-crewneck":{"id":"imperium-345-crewneck","collection":"THE IMPERIUM","title":"THE IMPERIUM CREWNECK","fit":"CROPPED OVERSIZED FIT","intro":"A shortened body, broad chest and extended shoulders establish an oversized cropped silhouette with substantial visual weight.","copy":"Designed with pronounced width, dropped shoulders and a compact body for the intended cropped oversized FEROBRILL proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[66,59,60,55],[68,61,62,56],[70,63,64,57],[72,65,66,58],[74,67,68,59]]},"imperium-350-quarterzip":{"id":"imperium-350-quarterzip","collection":"THE IMPERIUM","title":"THE IMPERIUM QUARTER-ZIP","fit":"RELAXED FIT","intro":"An extended body, dropped shoulders and measured chest volume create a relaxed pullover silhouette framed by a structured quarter-zip collar.","copy":"Designed with a relaxed silhouette, extended shoulder line and elongated body for controlled ease and architectural drape.","pos":3,"sizes":["S","M","L","XL","2XL"],"cm":[[61,71,53,60.5],[63,73,54.5,61.5],[65,75,56,62.5],[67,77,57.5,63.5],[69,79,59,64.5]]},"imperium-360-crewneck":{"id":"imperium-360-crewneck","collection":"THE IMPERIUM","title":"THE IMPERIUM CREWNECK","fit":"OVERSIZED FIT","intro":"An elongated body, substantial chest width and dropped shoulders establish an oversized silhouette with quiet structural authority.","copy":"Designed with an oversized silhouette, extended body and dropped shoulders. Select your usual size for the intended substantial FEROBRILL proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[62,70,57,57],[64,72,59,58],[66,74,61,59],[68,76,63,60],[70,78,65,61]]},"imperium-410-crop-collared":{"id":"imperium-410-crop-collared","collection":"THE IMPERIUM","title":"THE IMPERIUM CROP COLLARED SWEATSHIRT","fit":"CROPPED RELAXED FIT","intro":"A compact body, measured chest and dropped shoulder construction establish a relaxed cropped silhouette structured by a precise collar.","copy":"Designed with a cropped relaxed silhouette and balanced width through the chest, allowing the collar to remain the garment’s architectural anchor.","pos":3,"sizes":["S","M","L","XL","2XL"],"cm":[[55,47,47.5,55.5],[57,49,49.5,56.5],[59,51,51.5,57.5],[61,53,53.5,58.5],[63,55,55.5,59.5]]},"imperium-750-quarter-zip":{"id":"imperium-750-quarter-zip","collection":"THE IMPERIUM","title":"THE IMPERIUM QUARTER-ZIP","fit":"RELAXED STRUCTURED FIT","intro":"A measured body, substantial raglan sleeves and exceptional material density establish a relaxed pullover silhouette with pronounced structure.","copy":"Designed with a relaxed structured silhouette and raglan sleeve construction. The supplier does not provide a separate shoulder measurement for this garment.","pos":3,"sizes":["S","M","L","XL","2XL"],"cm":[[54,64,null,73],[56,66,null,74],[58,68,null,75],[60,70,null,76],[62,72,null,77]]},"chancellor-355-crewneck":{"id":"chancellor-355-crewneck","collection":"THE CHANCELLOR","title":"THE CHANCELLOR SWEATSHIRT","fit":"OVERSIZED LONG-LINE FIT","intro":"An elongated body, broad chest and dropped shoulders establish an oversized silhouette with a deliberate long-line drape.","copy":"Designed with an oversized long-line silhouette and progressive volume through the chest. Select your usual size for the intended extended proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"cm":[[63,71,58,57],[65,73,60,58],[67,75,62,59],[69,77,64,60],[71,79,66,61]]},"chancellor-350-crewneck":{"id":"chancellor-350-crewneck","collection":"THE CHANCELLOR","title":"THE CHANCELLOR CREWNECK","fit":"OVERSIZED FIT","intro":"Pronounced shoulder width, substantial chest volume and an extended body establish a commanding oversized silhouette.","copy":"Designed with an oversized silhouette, broad shoulder line and elongated body for deliberate scale and visual authority.","pos":4,"sizes":["M","L","XL","2XL"],"cm":[[63,75,64.5,59],[65,77,66,60],[67,79,67.5,61],[69,81,69,62]]},"reserve-360-reverie-pullover":{"id":"reserve-360-reverie-pullover","collection":"THE RESERVE","title":"THE RESERVE REVERIE PULLOVER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"reserve-380-brevity-sweatshirt":{"id":"reserve-380-brevity-sweatshirt","collection":"THE RESERVE","title":"THE RESERVE BREVITY SWEATSHIRT","fit":"LOOSE RAGLAN FIT","intro":"A loose straight body and long raglan sleeves establish a composed sweatshirt silhouette.","copy":"Sleeve length follows the raglan construction from the neckline to the sleeve opening. Compare the flat chest, body length and sleeve measurements with a similar sweatshirt you own.","pos":3,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[54,68,73.5],[56,70,75],[58,72,76.5],[60,74,78],[62,76,79.5],[64,77,81]]},"reserve-420-pullover":{"id":"reserve-420-pullover","collection":"THE RESERVE","title":"THE RESERVE PULLOVER","fit":"CROPPED OVERSIZED FIT","intro":"A broad chest, extended shoulder line and compact body establish a cropped oversized pullover silhouette.","copy":"Compare the flat garment measurements before selecting your size.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[70,62,64,52],[72,64,66,53],[74,66,68,54],[76,68,70,55],[78,70,72,56]]},"regent-crop-sweatshirt":{"id":"regent-crop-sweatshirt","collection":"THE REGENT","title":"THE REGENT CROP SWEATSHIRT","fit":"CROPPED REGULAR FIT","intro":"A compact cropped body, measured shoulder line and long sleeves establish a controlled sweatshirt silhouette with precise upper-body proportion.","copy":"Designed with a short body and balanced shoulder construction. Compare the flat chest, length, shoulder and sleeve measurements with a similar garment you own.","pos":2,"sizes":["S","M","L","XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[46,42,42.5,58],[48,43.5,44,59],[50,45,45.5,60],[52,46.5,47,61]]},"chancellor-400-ruched-flare-trouser":{"id":"chancellor-400-ruched-flare-trouser","collection":"THE CHANCELLOR","title":"THE CHANCELLOR RUCHED FLARE TROUSER","fit":"LOOSE FLARE-LEG FIT","intro":"A measured elasticated waist, relaxed hip and ruched lower leg establish a full-length flare silhouette with controlled movement.","copy":"Designed with a loose wide upper leg, gathered lower construction and restrained flare. Compare the flat waist and hip measurements before selecting your size.","pos":3,"sizes":["XS","S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[104,30,48],[106,32,50],[108,34,52],[110,36,54],[112,38,56]]},"imperium-350-relic-wide-leg-trouser":{"id":"imperium-350-relic-wide-leg-trouser","collection":"THE IMPERIUM","title":"THE IMPERIUM RELIC TROUSER","fit":"LOOSE WIDE-LEG FIT","intro":"A high-rise elasticated waist, measured hip and uninterrupted full-length leg establish a loose wide-leg silhouette with controlled raw-edge definition.","copy":"Designed with a drawstring waist, relaxed volume through the hip and a straight raw-edge hem. Compare the flat waist and hip dimensions before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[104,34,51.5],[106,36,53.5],[108,38,55.5],[110,40,57.5],[112,42,59.5]]},"dexterous-350-waffle-bermuda":{"id":"dexterous-350-waffle-bermuda","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE BERMUDA","fit":"LOOSE WIDE-LEG BERMUDA FIT","intro":"An extended knee-length body, measured mid-rise waist and generous hip establish a loose Bermuda silhouette that preserves the 350 GSM waffle structure.","copy":"Designed with an adjustable drawstring waist, substantial volume through the thigh and a clean straight hem.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[68,33,62],[69.5,35,64],[71,37,66],[72.5,39,68],[74,41,70]]},"imperium-bastion-straight-leg-trouser":{"id":"imperium-bastion-straight-leg-trouser","collection":"THE IMPERIUM","title":"THE IMPERIUM BASTION STRAIGHT-LEG TROUSER","fit":"LOOSE STRAIGHT-LEG FIT","intro":"A measured mid-rise waist, relaxed hip volume and uninterrupted full-length leg establish a loose straight silhouette with grounded vertical structure.","copy":"Designed with relaxed volume through the hip and leg before descending to a clean straight hem. Compare the flat waist and hip dimensions before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,33,55],[105,35,57],[107,37,59],[109,39,61],[111,41,63]]},"imperium-frame-barrel-leg-trouser":{"id":"imperium-frame-barrel-leg-trouser","collection":"THE IMPERIUM","title":"THE IMPERIUM FRAME BARREL-LEG TROUSER","fit":"LOOSE BARREL-LEG FIT","intro":"A measured mid-rise waist, controlled hip volume and a rounded full-length leg establish a sculpted barrel silhouette.","copy":"Designed with relaxed volume through the hip and thigh before narrowing subtly toward the ankle.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,32,54],[105,34,56],[107,36,58],[109,38,60],[111,40,62]]},"imperium-heritage-wide-leg-trouser":{"id":"imperium-heritage-wide-leg-trouser","collection":"THE IMPERIUM","title":"THE IMPERIUM HERITAGE WIDE-LEG TROUSER","fit":"LOOSE WIDE-LEG FIT","intro":"A gathered elasticated waist, generous hip and uninterrupted full-length leg establish a loose wide-leg silhouette with substantial vertical drape.","copy":"Designed with consistent width through the leg and a relaxed waistband. Compare the flat waist and hip dimensions before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[102,34,61],[104,36,63],[106,38,65],[108,40,67],[110,42,69]]},"imperium-frame-bermuda":{"id":"imperium-frame-bermuda","collection":"THE IMPERIUM","title":"THE IMPERIUM FRAME BERMUDA","fit":"LOOSE BERMUDA FIT","intro":"An extended short body, measured mid-rise waist and generous hip establish a loose H-line Bermuda silhouette.","copy":"Designed with substantial length, relaxed volume through the thigh and a straight raw-cut lower edge.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[62,32,56],[63.5,34,58],[65,36,60],[66.5,38,62],[68,40,64]]},"imperium-360-trouser":{"id":"imperium-360-trouser","collection":"THE IMPERIUM","title":"THE IMPERIUM TROUSER","fit":"LOOSE BARREL-LEG FIT","intro":"A measured mid-rise waist, generous hip and long barrel-shaped leg establish a relaxed silhouette with controlled volume.","copy":"Designed with a loose barrel-leg profile and measured taper. Compare the flat waist and hip dimensions before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,35,60],[105,37,62],[107,39,64],[109,41,66],[111,43,68]]},"regent-420-trouser":{"id":"regent-420-trouser","collection":"THE REGENT","title":"THE REGENT STRAIGHT-LEG TROUSER","fit":"LOOSE STRAIGHT-LEG FIT","intro":"A long straight leg, measured waist and progressive hip width establish a relaxed lower-body silhouette with a clean vertical line.","copy":"Designed with a loose straight-leg profile. Compare the flat waist and hip dimensions with a similar trouser you own.","pos":3,"sizes":["S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[102,32,53],[104,34,55],[106,36,57],[108,38,59]]},"reserve-wide-leg-trouser":{"id":"reserve-wide-leg-trouser","collection":"THE RESERVE","title":"THE RESERVE WIDE-LEG TROUSER","fit":"RELAXED WIDE-LEG FIT","intro":"A measured drawstring waist, balanced hip and full-length leg establish a relaxed straight wide-leg silhouette with controlled drape.","copy":"Waist and hip are flat widths measured with the waistband relaxed. Compare with a similar trouser you own.","pos":3,"sizes":["S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[100,33,51],[102,34.5,53],[104,36,55],[106,37.5,57]]},"reserve-crop-pullover":{"id":"reserve-crop-pullover","collection":"THE RESERVE","title":"THE RESERVE CROP PULLOVER","fit":"LOOSE CROPPED FIT","intro":"A compact body, broad chest and extended shoulders establish a loose cropped hooded silhouette with balanced sleeve length.","copy":"Chest, shoulder and waist-related dimensions are measured flat. Compare with a cropped pullover you own.","pos":4,"sizes":["S","M","L","XL"],"metrics":["LENGTH","SHOULDER","CHEST","SLEEVE"],"cm":[[43,48,51,56],[44.5,50,53,57],[46,52,55,58],[47.5,54,57,59]]},"reserve-crop-full-zip":{"id":"reserve-crop-full-zip","collection":"THE RESERVE","title":"THE RESERVE CROP FULL-ZIP","fit":"LOOSE CROPPED FIT","intro":"A compact body, measured chest and extended shoulders establish a loose cropped full-zip hooded silhouette.","copy":"Chest and shoulder dimensions are measured flat. Compare with a cropped full-zip garment you own.","pos":4,"sizes":["S","M","L","XL"],"metrics":["LENGTH","SHOULDER","CHEST","SLEEVE"],"cm":[[46,46,45,63],[47.5,48,47,64],[49,50,49,65],[50.5,52,51,66]]},"reserve-350-trouser":{"id":"reserve-350-trouser","collection":"THE RESERVE","title":"THE RESERVE TROUSER","fit":"RELAXED STRAIGHT-LEG FIT","intro":"An extended leg, measured waist and progressive hip width establish an easy straight silhouette with substantial fleece drape.","copy":"Designed with a relaxed straight-leg silhouette. Select your usual size for the intended FEROBRILL proportion.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[104,33,55],[106,35,57],[108,37,59],[110,39,61],[112,41,63]]},"chancellor-450-trouser":{"id":"chancellor-450-trouser","collection":"THE CHANCELLOR","title":"THE CHANCELLOR TROUSER","fit":"LOOSE STRAIGHT-LEG FIT","intro":"A long straight leg, measured waist and balanced hip width establish a composed silhouette with controlled ease.","copy":"Designed with a loose straight-leg profile and measured lower-body volume.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,32,53],[105,34,55],[107,36,57],[109,38,59],[111,40,61]]},"chancellor-wide-leg-trouser-360":{"id":"chancellor-wide-leg-trouser-360","collection":"THE CHANCELLOR","title":"THE CHANCELLOR WIDE-LEG TROUSER","fit":"OVERSIZED WIDE-LEG FIT","intro":"A long body, elastic waist and progressive hip width establish an oversized wide-leg silhouette with pronounced drape.","copy":"Designed with an oversized wide-leg profile. Compare the flat waist and hip dimensions before selecting your size.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[106,34,53.5],[107,36,55.5],[108,38,57.5],[109,40,59.5],[110,42,61.5]]},"chancellor-wide-leg-trouser-310":{"id":"chancellor-wide-leg-trouser-310","collection":"THE CHANCELLOR","title":"THE CHANCELLOR WIDE-LEG TROUSER","fit":"OVERSIZED WIDE-LEG FIT","intro":"A measured waist, broad hip and extended leg create a fluid wide-leg silhouette with controlled volume.","copy":"Designed with an oversized wide-leg silhouette. This 310 construction uses its own measurement specification.","pos":4,"sizes":["S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,33,56],[105,35,58],[107,37,60],[109,39,62]]},"dexterous-360-waffle-barrel-leg-trouser":{"id":"dexterous-360-waffle-barrel-leg-trouser","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE BARREL-LEG TROUSER","fit":"LOOSE BARREL-LEG FIT","intro":"A measured mid-rise waist, generous hip and full barrel-shaped leg establish a relaxed silhouette with controlled volume.","copy":"Designed with a loose barrel-leg profile and subtle taper. Compare the flat waist and hip dimensions before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[101,34,54],[103,36,56],[105,38,58],[107,40,60],[109,42,62]]},"dexterous-waffle-straight-leg-trouser":{"id":"dexterous-waffle-straight-leg-trouser","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE STRAIGHT-LEG TROUSER","fit":"LOOSE STRAIGHT-LEG FIT","intro":"An extended leg and generous hip establish a relaxed straight silhouette.","copy":"Designed with controlled volume through the hip.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,34,60],[105,36,62],[107,38,64],[109,40,66],[111,42,68]]},"chancellor-balloon-trouser":{"id":"chancellor-balloon-trouser","collection":"THE CHANCELLOR","title":"THE CHANCELLOR BALLOON TROUSER","fit":"LOOSE BALLOON FIT","intro":"A measured waist and generous hip establish a loose balloon silhouette.","copy":"Designed with controlled volume through the leg.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[104,32,58],[106,34,60],[108,36,62],[110,38,64],[112,40,66]]},"dexterous-340-bermuda":{"id":"dexterous-340-bermuda","collection":"THE DEXTEROUS","title":"THE DEXTEROUS BERMUDA","fit":"LOOSE BERMUDA FIT","intro":"A long short body, measured waist and generous hip establish a relaxed Bermuda silhouette that preserves the waffle structure.","copy":"Designed with a loose Bermuda proportion and measured volume through the hip.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[51,33,54.5],[52,35,56.5],[53,37,58.5],[54,39,60.5],[55,41,62.5]]},"reserve-355-bermuda":{"id":"reserve-355-bermuda","collection":"THE RESERVE","title":"THE RESERVE BERMUDA","fit":"LOOSE BERMUDA FIT","intro":"A substantial fleece body, measured waist and generous hip establish a relaxed mid-length short silhouette.","copy":"Designed with a loose Bermuda proportion and progressive ease through the hip.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[51,33,54.5],[52,35,56.5],[53,37,58.5],[54,39,60.5],[55,41,62.5]]},"chancellor-320-flare-trouser":{"id":"chancellor-320-flare-trouser","collection":"THE CHANCELLOR","title":"THE CHANCELLOR FLARE TROUSER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["LENGTH","WAIST","HIP"],"sizes":[],"cm":[]},"AUTARCH-450-WIDE-LEG-TROUSER":{"id":"AUTARCH-450-WIDE-LEG-TROUSER","collection":"THE AUTARCH","title":"THE AUTARCH WIDE-LEG TROUSER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["LENGTH","WAIST","HIP"],"sizes":[],"cm":[]},"AUTARCH-600-TRS-01":{"id":"AUTARCH-600-TRS-01","collection":"THE AUTARCH","title":"THE AUTARCH TROUSER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["LENGTH","WAIST","HIP"],"sizes":[],"cm":[]},"autarch-600-straight-leg-trouser":{"id":"autarch-600-straight-leg-trouser","collection":"THE AUTARCH","title":"THE AUTARCH STRAIGHT-LEG TROUSER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["LENGTH","WAIST","HIP"],"sizes":[],"cm":[]},"reserve-390-barrel-leg-trouser":{"id":"reserve-390-barrel-leg-trouser","collection":"THE RESERVE","title":"THE RESERVE BARREL-LEG TROUSER","fit":"RELAXED BARREL-LEG FIT","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,32,59],[105,34,61],[107,36,63],[109,38,65],[111,40,67]],"intro":"A gathered waist, generous hip and rounded leg establish a relaxed barrel silhouette with substantial 390 GSM structure.","copy":"Waist and hip are flat widths, measured with the waistband relaxed. Compare with a similar trouser you own."},"reserve-420-trouser":{"id":"reserve-420-trouser","collection":"THE RESERVE","title":"THE RESERVE TROUSER","fit":"LOOSE WIDE-LEG FIT","intro":"A measured waist, progressive hip and full-length leg establish a relaxed trouser silhouette.","copy":"Compare the flat waist and hip measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[102,32,56],[104,34,58],[106,36,60],[108,38,62],[110,40,64]]},"sovereign-high-rise-legging":{"id":"sovereign-high-rise-legging","collection":"THE SOVEREIGN","title":"THE SOVEREIGN HIGH-RISE LEGGING","fit":"SCULPTED HIGH-RISE FIT","intro":"A close high-rise silhouette follows the waist, hip and leg with controlled stretch.","copy":"Compare the flat waist and hip measurements with a fitted legging you own before selecting your size.","pos":2,"sizes":["4","6","8","10","12"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[83.4,25,35.5],[84.8,27,37.5],[86.2,29,39.5],[87.6,31,41.5],[89,33,43.5]]},"sovereign-sculpt-high-rise-skort":{"id":"sovereign-sculpt-high-rise-skort","collection":"THE SOVEREIGN","title":"THE SOVEREIGN SCULPT HIGH-RISE SKORT","fit":"SCULPTED HIGH-RISE FIT","intro":"A close high-rise waistband and fitted hip establish a compact sculpted skort silhouette.","copy":"Compare the flat waist and hip measurements before selecting your size.","pos":2,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[35,30,34],[36,32,36],[37,34,38],[38,36,40],[39,38,42]]},"sovereign-sculpt-high-rise-bermuda":{"id":"sovereign-sculpt-high-rise-bermuda","collection":"THE SOVEREIGN","title":"THE SOVEREIGN SCULPT HIGH-RISE BERMUDA","fit":"SCULPTED HIGH-RISE FIT","intro":"A close high-rise waist and compact fitted leg establish a sculpted Bermuda silhouette.","copy":"Waist and hip are flat widths measured with the stretch fabric relaxed. Compare with a fitted stretch Bermuda you own.","pos":0,"metrics":["LENGTH","WAIST","HIP"],"sizes":["S","M","L","XL","2XL"],"cm":[[20,25,34],[21,27,36],[22,29,38],[23,31,40],[24,33,42]]},"sovereign-sculpture-trouser":{"id":"sovereign-sculpture-trouser","collection":"THE SOVEREIGN","title":"THE SOVEREIGN SCULPTURE TROUSER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["LENGTH","WAIST","HIP"],"sizes":[],"cm":[]},"regent-barrel-leg-trouser":{"id":"regent-barrel-leg-trouser","collection":"THE REGENT","title":"THE REGENT BARREL-LEG TROUSER","fit":"LOOSE BARREL-LEG FIT","intro":"A measured elasticated waist, generous hip and rounded leg establish a relaxed barrel silhouette with controlled volume through the lower body.","copy":"Designed with a loose barrel-leg proportion and measured taper. Compare the flat waist and hip measurements with a similar trouser you own.","pos":3,"sizes":["S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[99,33,59],[101,35,61],[103,37,63],[105,39,65]]},"sovereign-drawstring-bermuda":{"id":"sovereign-drawstring-bermuda","collection":"THE SOVEREIGN","title":"THE SOVEREIGN DRAWSTRING BERMUDA","fit":"LOOSE HIGH-RISE FIT","intro":"A high-rise drawstring waist, generous hip and abbreviated athletic body establish a loose lightweight Bermuda silhouette.","copy":"Compare the flat waist and hip measurements before selecting your size.","pos":3,"sizes":["4","6","8","10","12"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[29.5,34,59],[30.5,36,61],[31.5,38,63],[32.5,40,65],[33.5,42,67]]},"sovereign-yoga-bermuda":{"id":"sovereign-yoga-bermuda","collection":"THE SOVEREIGN","title":"THE SOVEREIGN YOGA BERMUDA","fit":"SCULPTED HIGH-RISE FIT","intro":"A broad high-rise waistband, controlled hip and curved abbreviated hem establish a compact sculpted silhouette.","copy":"Compare the flat waist and hip measurements with a fitted Bermuda you own before selecting your size.","pos":2,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[33,28.5,48.5],[33.7,30.5,50.5],[34.4,32.5,52],[35,34.5,53.5],[35.8,36.5,55.5]]},"sovereign-paneled-yoga-bermuda":{"id":"sovereign-paneled-yoga-bermuda","collection":"THE SOVEREIGN","title":"THE SOVEREIGN PANELED YOGA BERMUDA","fit":"SLIM HIGH-RISE FIT","intro":"A high-rise elasticated waist and layered curved panel construction establish a compact technical silhouette.","copy":"Compare the flat waist and hip measurements with a fitted Bermuda you own before selecting your size.","pos":2,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[22,31.5,48],[23,33,50],[24,34.5,52],[25,36,54],[26,37.5,56]]},"reserve-420-raw-edge-bermuda":{"id":"reserve-420-raw-edge-bermuda","collection":"THE RESERVE","title":"THE RESERVE RAW EDGE BERMUDA","fit":"LOOSE EXTENDED BERMUDA FIT","intro":"A gathered mid-rise waist, generous hip and extended heavyweight leg establish a loose Bermuda silhouette with substantial cotton structure.","copy":"Designed with relaxed volume through the hip and thigh. Compare the flat waist and hip measurements with a similar Bermuda you own.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[62,32,56],[63.5,34,58],[65,36,60],[66.5,38,62],[68,40,64]]},"governor-denim-trouser":{"id":"governor-denim-trouser","collection":"THE GOVERNOR","title":"THE GOVERNOR DENIM TROUSER","fit":"LOOSE STRAIGHT FIT","intro":"A measured waist, progressive hip and controlled full length establish a loose denim silhouette with disciplined proportion.","copy":"Designed with a loose straight profile. Compare the flat waist and hip measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[97,37,51],[98,39,53],[99,41,55],[100,43,57],[101,45,59]]},"governor-wide-leg-denim-trouser-430":{"id":"governor-wide-leg-denim-trouser-430","collection":"THE GOVERNOR","title":"THE GOVERNOR WIDE-LEG DENIM TROUSER","fit":"LOOSE WIDE-LEG FIT","intro":"A long body, measured waist and progressive hip width establish a composed wide-leg denim silhouette.","copy":"Designed with a loose wide-leg profile. This 430 construction uses its own measurement specification.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[105,35,48.5],[106,37,50.5],[107,39,52.5],[108,41,54.5],[109,43,56.5]]},"governor-400-wide-leg-denim-trouser":{"id":"governor-400-wide-leg-denim-trouser","collection":"THE GOVERNOR","title":"THE GOVERNOR ENGINEERED WIDE-LEG DENIM TROUSER","fit":"LOOSE WIDE-LEG FIT","intro":"A controlled full length, measured waist and progressive hip establish a wide-leg denim silhouette with quiet structure.","copy":"Designed with a loose wide-leg profile. Select by comparing the flat waist and hip measurements.","pos":3,"sizes":["S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[102,34,49],[103,36,51],[104,38,53],[105,40,55]]},"governor-denim-jacket":{"id":"governor-denim-jacket","collection":"THE GOVERNOR","title":"THE GOVERNOR DENIM JACKET","fit":"LOOSE JACKET FIT","intro":"A measured body, regular shoulder and progressive chest width establish a composed denim jacket silhouette.","copy":"Designed with a loose jacket profile and balanced sleeve construction.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[55,66,48,62],[57,67.5,49,63],[59,69,50,64],[61,70.5,51,65],[63,72,52,66]]},"governor-denim-blouson":{"id":"governor-denim-blouson","collection":"THE GOVERNOR","title":"THE GOVERNOR DENIM BLOUSON","fit":"LOOSE BLOUSON FIT","intro":"A broad chest, extended shoulder line and compact body establish the intended architectural blouson silhouette.","copy":"Designed with a loose blouson profile, pronounced shoulder width and compact sleeve proportion.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[67,62,58,53],[69,63.5,59,54],[71,65,60,55],[73,66.5,61,56],[75,68,62,57]]},"governor-baggy-denim-short":{"id":"governor-baggy-denim-short","collection":"THE GOVERNOR","title":"THE GOVERNOR BAGGY DENIM BERMUDA","fit":"LOOSE BAGGY FIT","intro":"A long short body, measured waist and progressive hip width establish a relaxed baggy denim silhouette.","copy":"Designed with a loose baggy profile and measured volume through the hip.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[78,36,52],[79,38,54],[80,40,56],[81,42,58],[82,44,60]]},"governor-wide-leg-denim-trouser":{"id":"governor-wide-leg-denim-trouser","collection":"THE GOVERNOR","title":"THE GOVERNOR WIDE-LEG DENIM TROUSER","fit":"LOOSE WIDE-LEG FIT","intro":"A measured waist, progressive hip and full-length leg establish a composed wide-leg denim silhouette.","copy":"This construction follows its own verified measurement specification.","pos":3,"sizes":["S","M","L","XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[106,39,50.5],[107,41,52.5],[108,43,54.5],[109,45,56.5]]},"governor-barrel-leg-trouser":{"id":"governor-barrel-leg-trouser","collection":"THE GOVERNOR","title":"THE GOVERNOR BARREL-LEG TROUSER","fit":"LOOSE BARREL-LEG FIT","intro":"A measured mid-rise waist, progressive hip and rounded full-length leg establish a composed barrel silhouette with controlled structure.","copy":"Designed with volume through the hip and thigh before narrowing through the lower leg. Compare the flat waist and hip measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["LENGTH","WAIST","HIP"],"cm":[[103,35,52.5],[104,37,54.5],[105,39,56.5],[106,41,58.5],[107,43,60.5]]},"chancellor-400-cropped-full-zip":{"id":"chancellor-400-cropped-full-zip","collection":"THE CHANCELLOR","title":"THE CHANCELLOR RUCHED FULL-ZIP","fit":"RELAXED CROPPED FIT","intro":"A short body, controlled shoulder line and long lantern sleeves establish a compact full-zip silhouette with substantial cotton-rich weight.","copy":"Designed with a relaxed cropped proportion, shaped hood and secure rib-knit boundaries. Compare the flat garment measurements before selecting your size.","pos":3,"sizes":["XS","S","M","L","XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[46,48,38,59],[48,50,39.5,60],[50,52,41,61],[52,54,42.5,62],[54,56,44,63]]},"chancellor-400-lantern-full-zip":{"id":"chancellor-400-lantern-full-zip","collection":"THE CHANCELLOR","title":"THE CHANCELLOR LANTERN FULL-ZIP","fit":"RELAXED CROPPED FIT","intro":"A compact body, controlled shoulder line and extended lantern sleeves establish a sculpted full-zip silhouette with substantial 400 GSM cotton-rich weight.","copy":"Designed with a relaxed cropped proportion, shaped hood and secure rib-knit boundaries. Compare the flat garment measurements before selecting your size.","pos":3,"sizes":["XS","S","M","L","XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[46,48,38,59],[48,50,39.5,60],[50,52,41,61],[52,54,42.5,62],[54,56,44,63]]},"imperium-380-axis-full-zip":{"id":"imperium-380-axis-full-zip","collection":"THE IMPERIUM","title":"THE IMPERIUM AXIS FULL-ZIP","fit":"RELAXED H-LINE FIT","intro":"A straight H-line body, balanced shoulder line and set-in long sleeves establish a relaxed full-zip silhouette with measured 380 GSM structure.","copy":"Designed with a drawstring hood, full-front zip and clean rib-knit cuffs. Compare the flat garment measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[52.5,66,47.8,58.4],[54.5,68,49.4,59.2],[56.5,70,51,60],[58.5,72,52.6,60.8],[60.5,74,54.2,61.6],[62.5,76,55.8,62.4]]},"imperium-bastion-full-zip-hoodie":{"id":"imperium-bastion-full-zip-hoodie","collection":"THE IMPERIUM","title":"THE IMPERIUM BASTION FULL-ZIP","fit":"OVERSIZED BOXY FIT","intro":"A broad chest, pronounced dropped shoulders and compact body establish an oversized full-zip silhouette with substantial architectural volume.","copy":"Designed with a generously scaled hood, full front zip and broad boxy body for the intended BASTION proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[69,62,62,54],[71,63.5,63.5,55],[73,65,65,56],[75,66.5,66.5,57],[77,68,68,58]]},"imperium-bastion-hooded-pullover":{"id":"imperium-bastion-hooded-pullover","collection":"THE IMPERIUM","title":"THE IMPERIUM BASTION HOODED PULLOVER","fit":"OVERSIZED BOXY FIT","intro":"A broad chest, pronounced dropped shoulders and compact body establish an oversized hooded silhouette with substantial architectural volume.","copy":"Designed with a generously scaled hood, broad straight body and controlled rib-knit boundaries for the intended BASTION proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[69,62,62,54],[71,63.5,63.5,55],[73,65,65,56],[75,66.5,66.5,57],[77,68,68,58]]},"imperium-frame-full-zip-pullover":{"id":"imperium-frame-full-zip-pullover","collection":"THE IMPERIUM","title":"THE IMPERIUM FRAME FULL-ZIP","fit":"OVERSIZED BOXY FIT","intro":"A broad chest, pronounced dropped shoulders and compact body establish an oversized full-zip silhouette with controlled architectural volume.","copy":"Designed with a substantial hood, two-way full-zip closure and broad H-line body for the intended structured FRAME proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[72,60,65,55],[74,62,67,56],[76,64,69,57],[78,66,71,58],[80,68,73,59]]},"imperium-frame-hooded-pullover":{"id":"imperium-frame-hooded-pullover","collection":"THE IMPERIUM","title":"THE IMPERIUM FRAME HOODED PULLOVER","fit":"OVERSIZED BOXY FIT","intro":"A broad chest, relaxed shoulder construction and compact body establish an oversized hooded silhouette with concentrated fleece volume.","copy":"Designed with a substantial hood, broad H-line body and controlled rib-knit boundaries for the intended FRAME proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[72,59,65,55],[74,61,67,56],[76,63,69,57],[78,65,71,58],[80,67,73,59]]},"imperium-360-hoodie":{"id":"imperium-360-hoodie","collection":"THE IMPERIUM","title":"THE IMPERIUM HOODIE","fit":"OVERSIZED FIT","intro":"A broad chest, extended body and long sleeve establish the intended oversized hoodie silhouette.","copy":"Designed with an oversized silhouette and progressive volume through the body.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[62,67,68],[64,69,70],[66,71,72],[68,73,74],[70,75,76]]},"imperium-500-hoodie":{"id":"imperium-500-hoodie","collection":"THE IMPERIUM","title":"THE IMPERIUM HOODIE","fit":"CROPPED OVERSIZED FIT","intro":"Substantial chest width, a compact body and measured sleeves establish a cropped oversized silhouette with heavyweight structure.","copy":"Designed with a cropped oversized silhouette and heavyweight architectural proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[61,58.5,57],[63,60.5,59],[65,62.5,61],[67,64.5,63],[69,66.5,65]]},"reserve-350-hoodie":{"id":"reserve-350-hoodie","collection":"THE RESERVE","title":"THE RESERVE HOODIE","fit":"CROPPED OVERSIZED FIT","intro":"A broad chest, extended shoulder line and cropped body establish an oversized hoodie silhouette with controlled rawness.","copy":"Designed with a cropped oversized silhouette, broad chest and extended shoulders.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[71,63,66.5,59],[73,65,68,60],[75,67,69.5,61],[77,69,71,62],[79,71,72.5,63]]},"imperium-vector-hoodie":{"id":"imperium-vector-hoodie","collection":"THE IMPERIUM","title":"THE IMPERIUM VECTOR HOODIE","fit":"RELAXED FIT","intro":"A broad chest and raglan sleeves establish a relaxed hooded silhouette.","copy":"Shoulder measurement is not supplied for this raglan construction.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[63,65,82],[65,67,83.5],[67,69,85],[69,71,86.5],[71,73,88]]},"chancellor-signature-hooded-pullover":{"id":"chancellor-signature-hooded-pullover","collection":"THE CHANCELLOR","title":"THE CHANCELLOR AXIS PULLOVER","fit":"CROPPED OVERSIZED FIT","intro":"A broad chest and extended shoulders establish a cropped boxy silhouette.","copy":"Designed with deliberate architectural volume.","pos":4,"sizes":["S","M","L","XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[68,64,66,56],[70,66,68,57],[72,68,70,58],[74,70,72,59]]},"chancellor-full-zip-hooded-jacket":{"id":"chancellor-full-zip-hooded-jacket","collection":"THE CHANCELLOR","title":"THE CHANCELLOR FULL-ZIP HOODED JACKET","fit":"CROPPED OVERSIZED FIT","intro":"A compact body and dropped shoulders establish a cropped full-zip silhouette.","copy":"Designed with broad, controlled boxy proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[60,62,56,63],[62,64,58,64],[64,66,60,65],[66,68,62,66],[68,70,64,67]]},"chancellor-hooded-pullover":{"id":"chancellor-hooded-pullover","collection":"THE CHANCELLOR","title":"THE CHANCELLOR HOODED PULLOVER","fit":"CROPPED OVERSIZED FIT","intro":"A compact body and dropped shoulders establish a cropped hooded silhouette.","copy":"Designed with broad, controlled boxy proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[60,62,56,63],[62,64,58,64],[64,66,60,65],[66,68,62,66],[68,70,64,67]]},"dexterous-360-waffle-hoodie":{"id":"dexterous-360-waffle-hoodie","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE HOODIE","fit":"OVERSIZED FIT","intro":"An extended body, broad shoulder line and measured chest volume establish a relaxed oversized hoodie silhouette with composed waffle structure.","copy":"Designed with an oversized silhouette, dropped shoulders and balanced length for relaxed architectural proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[65,70,64,53],[67,72,66,54],[69,74,68,55],[71,76,70,56],[73,78,72,57]]},"dexterous-360-waffle-cropped-hoodie":{"id":"dexterous-360-waffle-cropped-hoodie","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE CROPPED HOODIE","fit":"CROPPED OVERSIZED FIT","intro":"A compact body, pronounced chest width and extended shoulders establish a cropped oversized silhouette with dimensional waffle structure.","copy":"Designed with a cropped boxy body, broad chest and dropped shoulders for deliberate volume and controlled proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[69,62,62,54],[71,63.5,63.5,55],[73,65,65,56],[75,66.5,66.5,57],[77,68,68,58]]},"dexterous-360-waffle-full-zip-jacket":{"id":"dexterous-360-waffle-full-zip-jacket","collection":"THE DEXTEROUS","title":"THE DEXTEROUS WAFFLE FULL-ZIP","fit":"CROPPED OVERSIZED FIT","intro":"A compact body, pronounced chest width and extended shoulders establish an oversized full-zip silhouette with dimensional waffle structure.","copy":"Designed with a cropped boxy body, broad chest and dropped shoulders, balanced by a full front zip for adaptable proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[69,62,62,54],[71,63.5,63.5,55],[73,65,65,56],[75,66.5,66.5,57],[77,68,68,58]]},"dexterous-archon-waffle-hooded-pullover":{"id":"dexterous-archon-waffle-hooded-pullover","collection":"THE DEXTEROUS","title":"THE DEXTEROUS ARCHON WAFFLE HOODED PULLOVER","fit":"OVERSIZED BOXY FIT","intro":"A broad chest, extended shoulder line and shortened body establish an oversized box-shaped silhouette with dimensional waffle structure.","copy":"Designed with pronounced width, dropped shoulders and a substantial hood for the intended structured proportion.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[69,62,62,54],[71,63.5,63.5,55],[73,65,65,56],[75,66.5,66.5,57],[77,68,68,58]]},"autarch-1000-hooded-pullover":{"id":"autarch-1000-hooded-pullover","collection":"THE AUTARCH","title":"THE AUTARCH HOODED PULLOVER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"autarch-750-pullover":{"id":"autarch-750-pullover","collection":"THE AUTARCH","title":"THE AUTARCH HOODED PULLOVER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"autarch-450-pullover":{"id":"autarch-450-pullover","collection":"THE AUTARCH","title":"THE AUTARCH HOODED PULLOVER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"autarch-600-hooded-pullover":{"id":"autarch-600-hooded-pullover","collection":"THE AUTARCH","title":"THE AUTARCH PATINA PULLOVER","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"imperium-360-full-zip":{"id":"imperium-360-full-zip","collection":"THE IMPERIUM","title":"THE IMPERIUM FULL-ZIP","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"imperium-420-knit-cardigan":{"id":"imperium-420-knit-cardigan","collection":"THE IMPERIUM","title":"THE IMPERIUM KNIT CARDIGAN","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"reserve-390-hooded-pullover":{"id":"reserve-390-hooded-pullover","collection":"THE RESERVE","title":"THE RESERVE HOODED PULLOVER","fit":"OVERSIZED BOXY FIT","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[68,63,62,53],[70,65,64,54],[72,67,66,55],[74,69,68,56],[76,71,70,57]],"intro":"A broad boxy body, dropped shoulders and generous sleeves establish the substantial 390 GSM hooded silhouette.","copy":"Chest is a flat width. Compare the chest, body length, shoulder and sleeve measurements with a similar hooded pullover you own."},"imperium-350-relic-pullover":{"id":"imperium-350-relic-pullover","collection":"THE IMPERIUM","title":"THE IMPERIUM RELIC PULLOVER","fit":"LOOSE FIT","intro":"A loose hooded body, full-length zip and long set-in sleeves establish a relaxed silhouette framed by raw edges.","copy":"Compare the flat chest, body length, shoulder and sleeve measurements with a similar full-zip hoodie you own.","pos":3,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[51,59,40,65],[53,61,41.5,66],[55,63,43,67],[57,65,44.5,68],[59,67,46,69]]},"imperium-420-pleated-hoodie":{"id":"imperium-420-pleated-hoodie","collection":"THE IMPERIUM","title":"THE IMPERIUM PLEATED HOODED PULLOVER","fit":"OVERSIZED FIT","intro":"A broad body, dropped shoulders and pleated sleeves establish a substantial hooded silhouette.","copy":"Compare the flat chest, body length, shoulder and sleeve measurements with a similar hooded pullover you own.","pos":4,"sizes":["S","M","L","XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[65,68,63,55],[67,70,65,56],[69,72,67,57],[71,74,69,58]]},"chancellor-cinched-full-zip":{"id":"chancellor-cinched-full-zip","collection":"THE CHANCELLOR","title":"THE CHANCELLOR CINCHED FULL-ZIP","fit":"SIZE SPECIFICATION PENDING","intro":"Registered within the FEROBRILL Master Size Guide. Verified production measurements are pending.","copy":"Verified production measurements are pending.","pos":2,"pending":true,"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"sizes":[],"cm":[]},"sovereign-full-zip-jacket":{"id":"sovereign-full-zip-jacket","collection":"THE SOVEREIGN","title":"THE SOVEREIGN FULL-ZIP JACKET","fit":"SCULPTED CROPPED FIT","intro":"A close technical body, compact length and long set-in sleeves establish a sculpted full-zip silhouette with controlled upper-body proportion.","copy":"Compare the flat chest, length, shoulder and sleeve measurements with a fitted technical jacket you own before selecting your size.","pos":2,"sizes":["S","M","L","XL"],"metrics":["CHEST","LENGTH","SHOULDER","SLEEVE"],"cm":[[39,44.5,33,64],[41,45.5,34,65],[43,46.5,35,66],[45,47.5,36,67]]},"imperium-full-zip-jacket":{"id":"imperium-full-zip-jacket","collection":"THE IMPERIUM","title":"THE IMPERIUM FULL-ZIP JACKET","fit":"LOOSE RAGLAN FIT","intro":"A straight body and extended raglan sleeve line establish a relaxed full-zip silhouette with balanced 380 GSM structure.","copy":"Designed with raglan sleeves. A separate shoulder measurement is not provided for this construction. Compare the flat chest, length and sleeve measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[52.5,65,72.5],[54.5,67,74],[56.5,69,75.5],[58.5,71,77],[60.5,73,78.5],[62.5,75,80]]},"imperium-apex-full-zip-jacket":{"id":"imperium-apex-full-zip-jacket","collection":"THE IMPERIUM","title":"THE IMPERIUM APEX FULL-ZIP JACKET","fit":"LOOSE RAGLAN FIT","intro":"A straight body and extended raglan sleeve line establish a relaxed full-zip silhouette with balanced 380 GSM structure.","copy":"Designed with raglan sleeves. A separate shoulder measurement is not provided for this construction. Compare the flat chest, length and sleeve measurements before selecting your size.","pos":3,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SLEEVE"],"cm":[[52.5,65,72.5],[54.5,67,74],[56.5,69,75.5],[58.5,71,77],[60.5,73,78.5],[62.5,75,80]]},"reserve-420-hooded-pullover":{"id":"reserve-420-hooded-pullover","collection":"THE RESERVE","title":"THE RESERVE HOODED PULLOVER","fit":"RELAXED OVERSIZED FIT","intro":"A broad chest, dropped shoulder line and extended heavyweight body establish a relaxed hooded silhouette with substantial 420 GSM structure.","copy":"Verified production measurements provide chest, body length and shoulder. Sleeve length is not included in this garment specification.","pos":4,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SHOULDER"],"cm":[[57,67,55],[59,69,57],[61,71,59],[63,73,61],[65,75,63],[67,77,65]]},"reserve-420-full-zip-hooded-pullover":{"id":"reserve-420-full-zip-hooded-pullover","collection":"THE RESERVE","title":"THE RESERVE FULL-ZIP HOODED PULLOVER","fit":"LOOSE OVERSIZED FIT","intro":"A broad chest, dropped shoulders and extended body establish a relaxed heavyweight full-zip hooded silhouette.","copy":"Verified production measurements provide chest, body length and shoulder. Sleeve length is not included in this garment specification.","pos":4,"sizes":["S","M","L","XL","2XL","3XL"],"metrics":["CHEST","LENGTH","SHOULDER"],"cm":[[57,67,55],[59,69,57],[61,71,59],[63,73,61],[65,75,63],[67,77,65]]},"reserve-420-raw-edge-full-zip":{"id":"reserve-420-raw-edge-full-zip","collection":"THE RESERVE","title":"THE RESERVE RAW EDGE FULL-ZIP","fit":"OVERSIZED CROPPED FIT","intro":"A broad chest, pronounced dropped shoulder line and shortened heavyweight body establish an oversized full-zip silhouette with deliberate raw-edge character.","copy":"Verified production measurements provide chest, body length and shoulder. Sleeve length is not included in this garment specification.","pos":4,"sizes":["S","M","L","XL","2XL"],"metrics":["CHEST","LENGTH","SHOULDER"],"cm":[[62,62,61],[64,64,63],[66,66,65],[68,68,67],[70,70,69]]}};

window.FerobrillFormGuides={"the-imperium-360-coordinates-verdant-earth":[{"form":"PULLOVER","guide":"imperium-360-hoodie"},{"form":"SWEATSHIRT","guide":"imperium-360-crewneck"},{"form":"TROUSER","guide":"imperium-360-trouser"}],"the-chancellor-coordinates-slate-horizon":[{"form":"FULL-ZIP","guide":"chancellor-full-zip-hooded-jacket"},{"form":"PULLOVER","guide":"chancellor-hooded-pullover"},{"form":"TROUSER","guide":"chancellor-balloon-trouser"}]};

/* FEROBRILL_COMPLETE_INLINE_SIZE_CHART_DATA_PATCH - BEGIN
 * Version: 2026-10-20-complete-v2
 * Source: draft theme 192699400480, templates/page.json
 * Master source MD5: dddb813a63c752a88d890041de37ba34
 * Source updated: 2026-10-20T17:56:34Z
 *
 * 123 distinct garment guide IDs: 110 populated charts, 13 pending.
 * 30 existing Master Guide aliases are alternate IDs, NOT extra garments.
 * All measurements are copied from the Master Guide in centimetres.
 * Null means NOT SUPPLIED. Pending records deliberately have NO sizes/rows.
 * Manufacturer accuracy has not been independently verified.
 *
 * INSTALL: append this complete block AFTER the original code in
 * Assets/fb-measurements.js, in the UNPUBLISHED theme, then save and reload.
 * Remove the older partial patch block if it was installed. Do not remove
 * the original window.FerobrillMeasurements or window.FerobrillFormGuides.
 * This is JavaScript: do not add <script> tags or put it in a Liquid field.
 *
 * This snapshot SYNCHRONIZES the chart fields for these 123 known IDs and
 * their 30 aliases. It preserves unrelated registry IDs, extra fields on
 * existing canonical records, and the entire FerobrillFormGuides mapping.
 * It does not assign products/forms, change the renderer or modify CSS.
 * Load before fb-product-refinements.js. This is NOT live synchronization.
 */
;(() => {
  'use strict';

  const source = {
    "sourceThemeId": "192699400480",
    "sourceThemeName": "FEROBRILL - CART GARMENT TITLES / OCT 19",
    "sourceFile": "templates/page.json",
    "sourceChecksumMd5": "dddb813a63c752a88d890041de37ba34",
    "sourceUpdatedAt": "2026-10-20T17:56:34Z",
    "snapshotDate": "2026-10-20",
    "totalRecords": 124,
    "populatedRecords": 111,
    "pendingRecords": 13,
    "aliasCount": 30,
    "note": "Copied from the existing Master Guide; not independently verified against manufacturer specifications. Static snapshot, not live synchronization.",
    "version": "2026-10-20-complete-v3",
    "sizeRows": 542,
    "numericMeasurementCells": 1893,
    "unsuppliedMeasurementCells": 10,
    "categories": {
      "tops": {
        "total": 18,
        "populated": 18,
        "pending": 0
      },
      "sweatshirts": {
        "total": 19,
        "populated": 18,
        "pending": 1
      },
      "bottoms": {
        "total": 37,
        "populated": 32,
        "pending": 5
      },
      "denim": {
        "total": 11,
        "populated": 11,
        "pending": 0
      },
      "outerwear": {
        "total": 38,
        "populated": 31,
        "pending": 7
      },
      "dresses": {
        "total": 1,
        "populated": 1,
        "pending": 0
      }
    },
    "datasetSha256": "04edc2f8c1bb4b722f8cb71480962aab1a43192e87767293f3e0a9f80349b0b2"
  };

  const records = [
    // TOPS
    {
      "id": "reserve-300",
      "category": "tops",
      "collection": "THE RESERVE",
      "title": "THE RESERVE T-SHIRT",
      "fit": "OVERSIZED FIT",
      "copy": "Designed with an oversized silhouette, dropped shoulders and a long, relaxed body for ease and architectural drape.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [53, 71, 50, 22],
        [56, 73, 53, 22.5],
        [59, 75, 56, 23],
        [62, 77, 59, 23.5],
        [65, 79, 62, 24]
      ]
    },
    {
      "id": "reserve-350",
      "category": "tops",
      "collection": "THE RESERVE",
      "title": "THE RESERVE T-SHIRT",
      "fit": "OVERSIZED FIT",
      "copy": "Designed with an oversized silhouette, dropped shoulders and a relaxed body. Select your usual size for the intended FEROBRILL fit, or size down for a closer silhouette.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [57, 73, 53, 26],
        [59, 75, 54, 26.5],
        [61, 76.5, 56, 27],
        [63, 78, 57, 27.5],
        [65, 79.5, 58, 28]
      ]
    },
    {
      "id": "reserve-400",
      "category": "tops",
      "collection": "THE RESERVE",
      "title": "THE RESERVE T-SHIRT",
      "fit": "BOXY OVERSIZED FIT",
      "copy": "Defined by substantial chest width, extended shoulders and a deliberately shortened body for a structured, boxy silhouette.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [61, 65, 57, 22.5],
        [63, 67, 59, 23],
        [65, 69, 61, 23.5],
        [67, 71, 63, 24],
        [69, 73, 65, 24.5]
      ]
    },
    {
      "id": "reserve-420-crop",
      "category": "tops",
      "collection": "THE RESERVE",
      "title": "THE RESERVE CROP T-SHIRT",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with a cropped oversized silhouette, broad chest and extended shoulders. Select your usual size for the intended architectural proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [61, 62, 57, 25],
        [63, 64, 59, 26],
        [65, 66, 61, 27],
        [67, 68, 63, 28],
        [69, 70, 65, 29]
      ]
    },
    {
      "id": "dexterous-340",
      "category": "tops",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE T-SHIRT",
      "fit": "RELAXED FIT",
      "copy": "Designed with a relaxed silhouette and dropped shoulders, allowing the waffle surface to retain ease without losing its composed line.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [57, 70, 56, 21],
        [59, 72, 57.5, 21.5],
        [61, 74, 59, 22],
        [63, 76, 60.5, 22.5],
        [65, 78, 62, 23]
      ]
    },
    {
      "id": "dexterous-340-waffle-t-shirt",
      "category": "tops",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE RAGLAN T-SHIRT",
      "fit": "RELAXED BOXY FIT",
      "copy": "Designed with measured volume and unrestricted movement.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [61, 62, 42],
        [63, 64, 44],
        [65, 66, 46],
        [67, 68, 48],
        [69, 70, 50]
      ]
    },
    {
      "id": "dexterous-340-crop",
      "category": "tops",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS CROP WAFFLE BOXY T-SHIRT",
      "fit": "CROPPED BOXY FIT",
      "copy": "Designed with a cropped boxy silhouette, generous chest width and extended shoulders for deliberate proportion and textural clarity.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [61, 62, 57, 25],
        [63, 64, 59, 26],
        [65, 66, 61, 27],
        [67, 68, 63, 28],
        [69, 70, 65, 29]
      ]
    },
    {
      "id": "dexterous-340-waffle-long-sleeve-t-shirt",
      "category": "tops",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE LONG-SLEEVE T-SHIRT",
      "fit": "RELAXED BOXY FIT",
      "copy": "Designed with a relaxed boxy silhouette, extended shoulders and measured sleeve length for composed everyday proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [63, 62, 62, 55],
        [65, 64, 64, 56],
        [67, 66, 66, 57],
        [69, 68, 68, 58],
        [71, 70, 70, 59]
      ]
    },
    {
      "id": "dexterous-350-waffle-frame-t-shirt",
      "category": "tops",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE FRAME T-SHIRT",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Designed with deliberate width through the chest, dropped shoulders and an extended elbow-length sleeve for the intended WAFFLE FRAME proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [61, 61, 59.5, 35.5],
        [63, 63, 61.5, 36.5],
        [65, 65, 63.5, 37.5],
        [67, 67, 65.5, 38.5],
        [69, 69, 67.5, 39.5]
      ]
    },
    {
      "id": "chancellor-350",
      "category": "tops",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR T-SHIRT",
      "fit": "BOXY OVERSIZED FIT",
      "copy": "Designed with pronounced width, dropped shoulders and a shortened body for the intended structured, boxy FEROBRILL proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [61, 65, 57, 22.5],
        [63, 67, 59, 23],
        [65, 69, 61, 23.5],
        [67, 71, 63, 24],
        [69, 73, 65, 24.5]
      ]
    },
    {
      "id": "regent-275-t-shirt",
      "category": "tops",
      "collection": "THE REGENT",
      "title": "THE REGENT BOXY T-SHIRT",
      "fit": "RELAXED OVERSIZED FIT",
      "copy": "Designed with an elongated relaxed body and dropped shoulders. Select your usual size for the intended volume, or size down for a closer proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [56, 71, 50.5, 20.5],
        [58, 73, 52, 21.5],
        [60, 75, 53.5, 22.5],
        [62, 77, 55, 23.5],
        [64, 79, 56.5, 24.5],
        [66, 81, 58, 25.5]
      ]
    },
    {
      "id": "regent-220-normcore-t-shirt",
      "category": "tops",
      "collection": "THE REGENT",
      "title": "THE REGENT NORMCORE T-SHIRT",
      "fit": "LOOSE H-LINE FIT",
      "copy": "Chest is a flat width. Compare the chest, body length, shoulder and sleeve measurements with a similar T-shirt you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [51, 68, 47, 21],
        [53.5, 70, 49, 21.5],
        [56, 72, 51, 22],
        [58.5, 74, 53, 22.5],
        [61, 76, 55, 23],
        [63.5, 78, 57, 23.5]
      ]
    },
    {
      "id": "sovereign-sculpt-frame-tee",
      "category": "tops",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN SCULPT FRAME TEE",
      "fit": "SCULPTED FIT",
      "copy": "Measurements are taken flat with the stretch fabric relaxed. Compare with a fitted stretch top you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [35, 39.5, 32, 15],
        [37, 40.5, 33.5, 16],
        [39, 41.5, 35, 17],
        [41, 42.5, 36.5, 18],
        [43, 43.5, 38, 19]
      ]
    },
    {
      "id": "sovereign-racer-top",
      "category": "tops",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN RACER TOP",
      "fit": "SCULPTED RACER FIT",
      "copy": "Compare the flat garment measurements with a fitted top you own before selecting your size.",
      "pending": false,
      "sizes": ["4", "6", "8", "10", "12"],
      "metrics": ["LENGTH", "BUST", "UNDERBUST"],
      "cm": [
        [30.5, 34, 30.5],
        [31.5, 36, 32.5],
        [32.5, 38, 34.5],
        [33.5, 40, 36.5],
        [34.5, 42, 38.5]
      ]
    },
    {
      "id": "sovereign-sculpt-square-neck",
      "category": "tops",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN SCULPT SQUARE-NECK",
      "fit": "SCULPTED LONGLINE FIT",
      "copy": "Compare the flat bust and underbust measurements with a fitted top you own before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "BUST", "UNDERBUST"],
      "cm": [
        [37.5, 32, 26],
        [38.5, 34, 28],
        [39.5, 36, 30],
        [40.5, 38, 32],
        [41.5, 40, 34]
      ]
    },
    {
      "id": "chancellor-310-v-neck-crop-t-shirt",
      "category": "tops",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR V-NECK CROP T-SHIRT",
      "fit": "LOOSE FIT",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [59, 61, 59, 56],
        [61, 63, 61, 57],
        [63, 65, 63, 58],
        [65, 67, 65, 59]
      ]
    },
    {
      "id": "regent-430-t-shirt",
      "category": "tops",
      "collection": "THE REGENT",
      "title": "THE REGENT 430 T-SHIRT",
      "fit": "LOOSE FIT",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [56, 71, 50.5, 20.5],
        [58, 73, 52, 21.5],
        [60, 75, 53.5, 22.5],
        [62, 77, 55, 23.5],
        [64, 79, 56.5, 24.5],
        [66, 81, 58, 25.5]
      ]
    },
    {
      "id": "sovereign-halter-top",
      "category": "tops",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN HALTER TOP",
      "fit": "SKINNY FIT",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["BUST", "UNDERBUST", "LENGTH"],
      "cm": [
        [35, 31, 30],
        [37, 33, 31],
        [39, 35, 32],
        [41, 37, 33]
      ]
    },
    // SWEATSHIRTS & PULLOVERS
    {
      "id": "chancellor-320-collared-pullover",
      "category": "sweatshirts",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR COLLARED PULLOVER",
      "fit": "RELAXED BOXY FIT",
      "copy": "Designed with a relaxed boxy proportion, abbreviated length and controlled rib-knit boundaries. Compare the flat garment measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [58, 46, 54, 57],
        [60, 48, 56, 59],
        [62, 50, 58, 61],
        [64, 52, 60, 63],
        [66, 54, 62, 65]
      ]
    },
    {
      "id": "imperium-bastion-crewneck",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM BASTION CREWNECK",
      "fit": "OVERSIZED H-LINE FIT",
      "copy": "Designed with substantial width through the chest, dropped shoulders and a clean vertical fall for the intended BASTION proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [66, 66, 57, 63],
        [68, 68, 58.5, 64],
        [70, 70, 60, 65],
        [72, 72, 61.5, 66],
        [74, 74, 63, 67]
      ]
    },
    {
      "id": "imperium-frame-crewneck",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FRAME CREWNECK",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with substantial width, an extended shoulder line and a shortened body for the intended structured FRAME proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [66, 59, 60, 55],
        [68, 61, 62, 56],
        [70, 63, 64, 57],
        [72, 65, 66, 58],
        [74, 67, 68, 59]
      ]
    },
    {
      "id": "imperium-heritage-crewneck",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM HERITAGE CREWNECK",
      "fit": "LOOSE OVERSIZED FIT",
      "copy": "Designed with an expansive torso, extended shoulder line and controlled rib-knit boundaries. Select your usual size for the intended HERITAGE proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [62, 70, 57, 57],
        [64, 72, 59, 58],
        [66, 74, 61, 59],
        [68, 76, 63, 60],
        [70, 78, 65, 61]
      ]
    },
    {
      "id": "reserve-360-crewneck",
      "category": "sweatshirts",
      "collection": "THE RESERVE",
      "title": "THE RESERVE CREWNECK",
      "fit": "BOXY OVERSIZED FIT",
      "copy": "Designed with a boxy oversized silhouette, pronounced chest width and dropped shoulders for deliberate architectural proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [66, 60, 60, 55],
        [68, 62, 62, 56],
        [70, 64, 64, 57],
        [72, 66, 66, 58],
        [74, 68, 68, 59]
      ]
    },
    {
      "id": "regent-400-crewneck",
      "category": "sweatshirts",
      "collection": "THE REGENT",
      "title": "THE REGENT CREWNECK",
      "fit": "REGULAR FIT",
      "copy": "Designed with a regular silhouette and balanced proportions. Select your usual size for the intended composed FEROBRILL fit.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [57, 65, null, 60],
        [59, 67, null, 62],
        [61, 69, null, 64],
        [64, 71, null, 67],
        [67, 74, null, 70]
      ]
    },
    {
      "id": "imperium-280-crop-vneck",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM CROP V-NECK",
      "fit": "CROPPED RELAXED FIT",
      "copy": "Designed with a cropped relaxed silhouette, extended shoulders and controlled width through the chest for an intentional compact proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [64, 59, 53, 59],
        [66, 61, 54.5, 60],
        [68, 63, 56, 61],
        [70, 65, 57.5, 62]
      ]
    },
    {
      "id": "imperium-345-crewneck",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM CREWNECK",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with pronounced width, dropped shoulders and a compact body for the intended cropped oversized FEROBRILL proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [66, 59, 60, 55],
        [68, 61, 62, 56],
        [70, 63, 64, 57],
        [72, 65, 66, 58],
        [74, 67, 68, 59]
      ]
    },
    {
      "id": "imperium-350-quarterzip",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM QUARTER-ZIP",
      "fit": "RELAXED FIT",
      "copy": "Designed with a relaxed silhouette, extended shoulder line and elongated body for controlled ease and architectural drape.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [61, 71, 53, 60.5],
        [63, 73, 54.5, 61.5],
        [65, 75, 56, 62.5],
        [67, 77, 57.5, 63.5],
        [69, 79, 59, 64.5]
      ]
    },
    {
      "id": "imperium-360-crewneck",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM CREWNECK",
      "fit": "OVERSIZED FIT",
      "copy": "Designed with an oversized silhouette, extended body and dropped shoulders. Select your usual size for the intended substantial FEROBRILL proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [62, 70, 57, 57],
        [64, 72, 59, 58],
        [66, 74, 61, 59],
        [68, 76, 63, 60],
        [70, 78, 65, 61]
      ]
    },
    {
      "id": "imperium-410-crop-collared",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM CROP COLLARED SWEATSHIRT",
      "fit": "CROPPED RELAXED FIT",
      "copy": "Designed with a cropped relaxed silhouette and balanced width through the chest, allowing the collar to remain the garment\u2019s architectural anchor.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [55, 47, 47.5, 55.5],
        [57, 49, 49.5, 56.5],
        [59, 51, 51.5, 57.5],
        [61, 53, 53.5, 58.5],
        [63, 55, 55.5, 59.5]
      ]
    },
    {
      "id": "imperium-750-quarter-zip",
      "category": "sweatshirts",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM QUARTER-ZIP",
      "fit": "RELAXED STRUCTURED FIT",
      "copy": "Designed with a relaxed structured silhouette and raglan sleeve construction. The supplier does not provide a separate shoulder measurement for this garment.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [54, 64, null, 73],
        [56, 66, null, 74],
        [58, 68, null, 75],
        [60, 70, null, 76],
        [62, 72, null, 77]
      ]
    },
    {
      "id": "chancellor-355-crewneck",
      "category": "sweatshirts",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR SWEATSHIRT",
      "fit": "OVERSIZED LONG-LINE FIT",
      "copy": "Designed with an oversized long-line silhouette and progressive volume through the chest. Select your usual size for the intended extended proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [63, 71, 58, 57],
        [65, 73, 60, 58],
        [67, 75, 62, 59],
        [69, 77, 64, 60],
        [71, 79, 66, 61]
      ]
    },
    {
      "id": "chancellor-350-crewneck",
      "category": "sweatshirts",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR CREWNECK",
      "fit": "OVERSIZED FIT",
      "copy": "Designed with an oversized silhouette, broad shoulder line and elongated body for deliberate scale and visual authority.",
      "pending": false,
      "sizes": ["M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [63, 75, 64.5, 59],
        [65, 77, 66, 60],
        [67, 79, 67.5, 61],
        [69, 81, 69, 62]
      ]
    },
    {
      "id": "reserve-360-reverie-pullover",
      "category": "sweatshirts",
      "collection": "THE RESERVE",
      "title": "THE RESERVE REVERIE PULLOVER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "chancellor-350-distressed-sweatshirt",
      "category": "sweatshirts",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR DISTRESSED SWEATSHIRT",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [63, 75, 64.5, 59],
        [65, 77, 66, 60],
        [67, 79, 67.5, 61],
        [69, 81, 69, 62]
      ]
    },
    {
      "id": "reserve-380-brevity-sweatshirt",
      "category": "sweatshirts",
      "collection": "THE RESERVE",
      "title": "THE RESERVE BREVITY SWEATSHIRT",
      "fit": "LOOSE RAGLAN FIT",
      "copy": "Sleeve length follows the raglan construction from the neckline to the sleeve opening. Compare the flat chest, body length and sleeve measurements with a similar sweatshirt you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [54, 68, 73.5],
        [56, 70, 75],
        [58, 72, 76.5],
        [60, 74, 78],
        [62, 76, 79.5],
        [64, 77, 81]
      ]
    },
    {
      "id": "reserve-420-pullover",
      "category": "sweatshirts",
      "collection": "THE RESERVE",
      "title": "THE RESERVE PULLOVER",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Compare the flat garment measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [70, 62, 64, 52],
        [72, 64, 66, 53],
        [74, 66, 68, 54],
        [76, 68, 70, 55],
        [78, 70, 72, 56]
      ]
    },
    {
      "id": "regent-crop-sweatshirt",
      "category": "sweatshirts",
      "collection": "THE REGENT",
      "title": "THE REGENT CROP SWEATSHIRT",
      "fit": "CROPPED REGULAR FIT",
      "copy": "Designed with a short body and balanced shoulder construction. Compare the flat chest, length, shoulder and sleeve measurements with a similar garment you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [46, 42, 42.5, 58],
        [48, 43.5, 44, 59],
        [50, 45, 45.5, 60],
        [52, 46.5, 47, 61]
      ]
    },
    // TROUSERS & SHORTS
    {
      "id": "chancellor-400-ruched-flare-trouser",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR RUCHED FLARE TROUSER",
      "fit": "LOOSE FLARE-LEG FIT",
      "copy": "Designed with a loose wide upper leg, gathered lower construction and restrained flare. Compare the flat waist and hip measurements before selecting your size.",
      "pending": false,
      "sizes": ["XS", "S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [104, 30, 48],
        [106, 32, 50],
        [108, 34, 52],
        [110, 36, 54],
        [112, 38, 56]
      ]
    },
    {
      "id": "imperium-350-relic-wide-leg-trouser",
      "category": "bottoms",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM RELIC TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "Designed with a drawstring waist, relaxed volume through the hip and a straight raw-edge hem. Compare the flat waist and hip dimensions before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [104, 34, 51.5],
        [106, 36, 53.5],
        [108, 38, 55.5],
        [110, 40, 57.5],
        [112, 42, 59.5]
      ]
    },
    {
      "id": "dexterous-350-waffle-bermuda",
      "category": "bottoms",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE BERMUDA",
      "fit": "LOOSE WIDE-LEG BERMUDA FIT",
      "copy": "Designed with an adjustable drawstring waist, substantial volume through the thigh and a clean straight hem.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [68, 33, 62],
        [69.5, 35, 64],
        [71, 37, 66],
        [72.5, 39, 68],
        [74, 41, 70]
      ]
    },
    {
      "id": "imperium-bastion-straight-leg-trouser",
      "category": "bottoms",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM BASTION STRAIGHT-LEG TROUSER",
      "fit": "LOOSE STRAIGHT-LEG FIT",
      "copy": "Designed with relaxed volume through the hip and leg before descending to a clean straight hem. Compare the flat waist and hip dimensions before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 33, 55],
        [105, 35, 57],
        [107, 37, 59],
        [109, 39, 61],
        [111, 41, 63]
      ]
    },
    {
      "id": "imperium-frame-barrel-leg-trouser",
      "category": "bottoms",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FRAME BARREL-LEG TROUSER",
      "fit": "LOOSE BARREL-LEG FIT",
      "copy": "Designed with relaxed volume through the hip and thigh before narrowing subtly toward the ankle.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 32, 54],
        [105, 34, 56],
        [107, 36, 58],
        [109, 38, 60],
        [111, 40, 62]
      ]
    },
    {
      "id": "imperium-heritage-wide-leg-trouser",
      "category": "bottoms",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM HERITAGE WIDE-LEG TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "Designed with consistent width through the leg and a relaxed waistband. Compare the flat waist and hip dimensions before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [102, 34, 61],
        [104, 36, 63],
        [106, 38, 65],
        [108, 40, 67],
        [110, 42, 69]
      ]
    },
    {
      "id": "imperium-frame-bermuda",
      "category": "bottoms",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FRAME BERMUDA",
      "fit": "LOOSE BERMUDA FIT",
      "copy": "Designed with substantial length, relaxed volume through the thigh and a straight raw-cut lower edge.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [62, 32, 56],
        [63.5, 34, 58],
        [65, 36, 60],
        [66.5, 38, 62],
        [68, 40, 64]
      ]
    },
    {
      "id": "imperium-360-trouser",
      "category": "bottoms",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM TROUSER",
      "fit": "LOOSE BARREL-LEG FIT",
      "copy": "Designed with a loose barrel-leg profile and measured taper. Compare the flat waist and hip dimensions before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 35, 60],
        [105, 37, 62],
        [107, 39, 64],
        [109, 41, 66],
        [111, 43, 68]
      ]
    },
    {
      "id": "regent-420-trouser",
      "category": "bottoms",
      "collection": "THE REGENT",
      "title": "THE REGENT STRAIGHT-LEG TROUSER",
      "fit": "LOOSE STRAIGHT-LEG FIT",
      "copy": "Designed with a loose straight-leg profile. Compare the flat waist and hip dimensions with a similar trouser you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [102, 32, 53],
        [104, 34, 55],
        [106, 36, 57],
        [108, 38, 59]
      ]
    },
    {
      "id": "reserve-350-trouser",
      "category": "bottoms",
      "collection": "THE RESERVE",
      "title": "THE RESERVE TROUSER",
      "fit": "RELAXED STRAIGHT-LEG FIT",
      "copy": "Designed with a relaxed straight-leg silhouette. Select your usual size for the intended FEROBRILL proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [104, 33, 55],
        [106, 35, 57],
        [108, 37, 59],
        [110, 39, 61],
        [112, 41, 63]
      ]
    },
    {
      "id": "chancellor-450-trouser",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR TROUSER",
      "fit": "LOOSE STRAIGHT-LEG FIT",
      "copy": "Designed with a loose straight-leg profile and measured lower-body volume.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 32, 53],
        [105, 34, 55],
        [107, 36, 57],
        [109, 38, 59],
        [111, 40, 61]
      ]
    },
    {
      "id": "chancellor-wide-leg-trouser-360",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR WIDE-LEG TROUSER",
      "fit": "OVERSIZED WIDE-LEG FIT",
      "copy": "Designed with an oversized wide-leg profile. Compare the flat waist and hip dimensions before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [106, 34, 53.5],
        [107, 36, 55.5],
        [108, 38, 57.5],
        [109, 40, 59.5],
        [110, 42, 61.5]
      ]
    },
    {
      "id": "chancellor-wide-leg-trouser-310",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR WIDE-LEG TROUSER",
      "fit": "OVERSIZED WIDE-LEG FIT",
      "copy": "Designed with an oversized wide-leg silhouette. This 310 construction uses its own measurement specification.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 33, 56],
        [105, 35, 58],
        [107, 37, 60],
        [109, 39, 62]
      ]
    },
    {
      "id": "dexterous-360-waffle-barrel-leg-trouser",
      "category": "bottoms",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE BARREL-LEG TROUSER",
      "fit": "LOOSE BARREL-LEG FIT",
      "copy": "Designed with a loose barrel-leg profile and subtle taper. Compare the flat waist and hip dimensions before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [101, 34, 54],
        [103, 36, 56],
        [105, 38, 58],
        [107, 40, 60],
        [109, 42, 62]
      ]
    },
    {
      "id": "dexterous-waffle-straight-leg-trouser",
      "category": "bottoms",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE STRAIGHT-LEG TROUSER",
      "fit": "LOOSE STRAIGHT-LEG FIT",
      "copy": "Designed with controlled volume through the hip.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 34, 60],
        [105, 36, 62],
        [107, 38, 64],
        [109, 40, 66],
        [111, 42, 68]
      ]
    },
    {
      "id": "chancellor-balloon-trouser",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR BALLOON TROUSER",
      "fit": "LOOSE BALLOON FIT",
      "copy": "Designed with controlled volume through the leg.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [104, 32, 58],
        [106, 34, 60],
        [108, 36, 62],
        [110, 38, 64],
        [112, 40, 66]
      ]
    },
    {
      "id": "dexterous-340-bermuda",
      "category": "bottoms",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS BERMUDA",
      "fit": "LOOSE BERMUDA FIT",
      "copy": "Designed with a loose Bermuda proportion and measured volume through the hip.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [51, 33, 54.5],
        [52, 35, 56.5],
        [53, 37, 58.5],
        [54, 39, 60.5],
        [55, 41, 62.5]
      ]
    },
    {
      "id": "reserve-355-bermuda",
      "category": "bottoms",
      "collection": "THE RESERVE",
      "title": "THE RESERVE BERMUDA",
      "fit": "LOOSE BERMUDA FIT",
      "copy": "Designed with a loose Bermuda proportion and progressive ease through the hip.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [51, 33, 54.5],
        [52, 35, 56.5],
        [53, 37, 58.5],
        [54, 39, 60.5],
        [55, 41, 62.5]
      ]
    },
    {
      "id": "chancellor-320-flare-trouser",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR FLARE TROUSER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": []
    },
    {
      "id": "AUTARCH-450-WIDE-LEG-TROUSER",
      "category": "bottoms",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH WIDE-LEG TROUSER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": []
    },
    {
      "id": "AUTARCH-600-TRS-01",
      "category": "bottoms",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH TROUSER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": []
    },
    {
      "id": "autarch-600-straight-leg-trouser",
      "category": "bottoms",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH STRAIGHT-LEG TROUSER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": []
    },
    {
      "id": "chancellor-flare-trouser",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR FLARE TROUSER",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [97, 29, 44],
        [99, 31, 46],
        [101, 33, 48],
        [103, 35, 50],
        [105, 37, 52]
      ]
    },
    {
      "id": "chancellor-straight-leg-trouser",
      "category": "bottoms",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR STRAIGHT-LEG TROUSER",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 33, 55],
        [105, 35, 57],
        [107, 37, 59]
      ]
    },
    {
      "id": "regent-trouser",
      "category": "bottoms",
      "collection": "THE REGENT",
      "title": "THE REGENT TROUSER",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [97, 34, 56],
        [99, 36, 58],
        [101, 38, 60],
        [103, 40, 62],
        [105, 42, 64]
      ]
    },
    {
      "id": "reserve-wide-leg-trouser",
      "category": "bottoms",
      "collection": "THE RESERVE",
      "title": "THE RESERVE WIDE-LEG TROUSER",
      "fit": "STRAIGHT WIDE-LEG FIT",
      "copy": "Waist and hip measurements are taken flat. Compare the length, waist and hip measurements with a similar trouser you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [100, 33, 51],
        [102, 34.5, 53],
        [104, 36, 55],
        [106, 37.5, 57]
      ]
    },
    {
      "id": "reserve-390-barrel-leg-trouser",
      "category": "bottoms",
      "collection": "THE RESERVE",
      "title": "THE RESERVE BARREL-LEG TROUSER",
      "fit": "RELAXED BARREL-LEG FIT",
      "copy": "Waist and hip are flat widths, measured with the waistband relaxed. Compare with a similar trouser you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 32, 59],
        [105, 34, 61],
        [107, 36, 63],
        [109, 38, 65],
        [111, 40, 67]
      ]
    },
    {
      "id": "reserve-420-trouser",
      "category": "bottoms",
      "collection": "THE RESERVE",
      "title": "THE RESERVE TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "Compare the flat waist and hip measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [102, 32, 56],
        [104, 34, 58],
        [106, 36, 60],
        [108, 38, 62],
        [110, 40, 64]
      ]
    },
    {
      "id": "sovereign-high-rise-legging",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN HIGH-RISE LEGGING",
      "fit": "SCULPTED HIGH-RISE FIT",
      "copy": "Compare the flat waist and hip measurements with a fitted legging you own before selecting your size.",
      "pending": false,
      "sizes": ["4", "6", "8", "10", "12"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [83.4, 25, 35.5],
        [84.8, 27, 37.5],
        [86.2, 29, 39.5],
        [87.6, 31, 41.5],
        [89, 33, 43.5]
      ]
    },
    {
      "id": "sovereign-sculpt-high-rise-skort",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN SCULPT HIGH-RISE SKORT",
      "fit": "SCULPTED HIGH-RISE FIT",
      "copy": "Compare the flat waist and hip measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [35, 30, 34],
        [36, 32, 36],
        [37, 34, 38],
        [38, 36, 40],
        [39, 38, 42]
      ]
    },
    {
      "id": "sovereign-sculpt-high-rise-bermuda",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN SCULPT HIGH-RISE BERMUDA",
      "fit": "SCULPTED HIGH-RISE FIT",
      "copy": "Waist and hip are flat widths measured with the stretch fabric relaxed. Compare with a fitted stretch Bermuda you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [20, 25, 34],
        [21, 27, 36],
        [22, 29, 38],
        [23, 31, 40],
        [24, 33, 42]
      ]
    },
    {
      "id": "sovereign-sculpture-trouser",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN SCULPTURE TROUSER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "Verified production measurements are pending.",
      "pending": true,
      "sizes": [],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": []
    },
    {
      "id": "regent-barrel-leg-trouser",
      "category": "bottoms",
      "collection": "THE REGENT",
      "title": "THE REGENT BARREL-LEG TROUSER",
      "fit": "LOOSE BARREL-LEG FIT",
      "copy": "Designed with a loose barrel-leg proportion and measured taper. Compare the flat waist and hip measurements with a similar trouser you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [99, 33, 59],
        [101, 35, 61],
        [103, 37, 63],
        [105, 39, 65]
      ]
    },
    {
      "id": "sovereign-drawstring-bermuda",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN DRAWSTRING BERMUDA",
      "fit": "LOOSE HIGH-RISE FIT",
      "copy": "Compare the flat waist and hip measurements before selecting your size.",
      "pending": false,
      "sizes": ["4", "6", "8", "10", "12"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [29.5, 34, 59],
        [30.5, 36, 61],
        [31.5, 38, 63],
        [32.5, 40, 65],
        [33.5, 42, 67]
      ]
    },
    {
      "id": "sovereign-yoga-bermuda",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN YOGA BERMUDA",
      "fit": "SCULPTED HIGH-RISE FIT",
      "copy": "Compare the flat waist and hip measurements with a fitted Bermuda you own before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [33, 28.5, 48.5],
        [33.7, 30.5, 50.5],
        [34.4, 32.5, 52],
        [35, 34.5, 53.5],
        [35.8, 36.5, 55.5]
      ]
    },
    {
      "id": "sovereign-paneled-yoga-bermuda",
      "category": "bottoms",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN PANELED YOGA BERMUDA",
      "fit": "SLIM HIGH-RISE FIT",
      "copy": "Compare the flat waist and hip measurements with a fitted Bermuda you own before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [22, 31.5, 48],
        [23, 33, 50],
        [24, 34.5, 52],
        [25, 36, 54],
        [26, 37.5, 56]
      ]
    },
    {
      "id": "reserve-420-raw-edge-bermuda",
      "category": "bottoms",
      "collection": "THE RESERVE",
      "title": "THE RESERVE RAW EDGE BERMUDA",
      "fit": "LOOSE EXTENDED BERMUDA FIT",
      "copy": "Designed with relaxed volume through the hip and thigh. Compare the flat waist and hip measurements with a similar Bermuda you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [62, 32, 56],
        [63.5, 34, 58],
        [65, 36, 60],
        [66.5, 38, 62],
        [68, 40, 64]
      ]
    },
    // DENIM
    {
      "id": "governor-denim-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR DENIM TROUSER",
      "fit": "LOOSE STRAIGHT FIT",
      "copy": "Designed with a loose straight profile. Compare the flat waist and hip measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [97, 37, 51],
        [98, 39, 53],
        [99, 41, 55],
        [100, 43, 57],
        [101, 45, 59]
      ]
    },
    {
      "id": "governor-wide-leg-denim-trouser-430",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR WIDE-LEG DENIM TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "Designed with a loose wide-leg profile. This 430 construction uses its own measurement specification.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [105, 35, 48.5],
        [106, 37, 50.5],
        [107, 39, 52.5],
        [108, 41, 54.5],
        [109, 43, 56.5]
      ]
    },
    {
      "id": "governor-400-wide-leg-denim-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR ENGINEERED WIDE-LEG DENIM TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "Designed with a loose wide-leg profile. Select by comparing the flat waist and hip measurements.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [102, 34, 49],
        [103, 36, 51],
        [104, 38, 53],
        [105, 40, 55]
      ]
    },
    {
      "id": "governor-denim-jacket",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR DENIM JACKET",
      "fit": "LOOSE JACKET FIT",
      "copy": "Designed with a loose jacket profile and balanced sleeve construction.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [55, 66, 48, 62],
        [57, 67.5, 49, 63],
        [59, 69, 50, 64],
        [61, 70.5, 51, 65],
        [63, 72, 52, 66]
      ]
    },
    {
      "id": "governor-denim-blouson",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR DENIM BLOUSON",
      "fit": "LOOSE BLOUSON FIT",
      "copy": "Designed with a loose blouson profile, pronounced shoulder width and compact sleeve proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [67, 62, 58, 53],
        [69, 63.5, 59, 54],
        [71, 65, 60, 55],
        [73, 66.5, 61, 56],
        [75, 68, 62, 57]
      ]
    },
    {
      "id": "governor-baggy-denim-short",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR BAGGY DENIM BERMUDA",
      "fit": "LOOSE BAGGY FIT",
      "copy": "Designed with a loose baggy profile and measured volume through the hip.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [78, 36, 52],
        [79, 38, 54],
        [80, 40, 56],
        [81, 42, 58],
        [82, 44, 60]
      ]
    },
    {
      "id": "governor-column-denim-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR COLUMN DENIM TROUSER",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [104, 34, 51.5],
        [105, 36, 53.5],
        [106, 38, 55.5],
        [107, 40, 57.5],
        [108, 42, 59.5]
      ]
    },
    {
      "id": "governor-engineered-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR ENGINEERED DENIM TROUSER",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [102, 35, 52],
        [103, 37, 54],
        [104, 39, 56],
        [105, 41, 58],
        [106, 43, 60]
      ]
    },
    {
      "id": "governor-wide-leg-denim-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR WIDE-LEG DENIM TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "This construction follows its own verified measurement specification.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [106, 39, 50.5],
        [107, 41, 52.5],
        [108, 43, 54.5],
        [109, 45, 56.5]
      ]
    },
    {
      "id": "governor-barrel-leg-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR BARREL-LEG TROUSER",
      "fit": "LOOSE BARREL-LEG FIT",
      "copy": "Designed with volume through the hip and thigh before narrowing through the lower leg. Compare the flat waist and hip measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [103, 35, 52.5],
        [104, 37, 54.5],
        [105, 39, 56.5],
        [106, 41, 58.5],
        [107, 43, 60.5]
      ]
    },
    {
      "id": "governor-vintage-wide-leg-denim-trouser",
      "category": "denim",
      "collection": "THE GOVERNOR",
      "title": "THE GOVERNOR VINTAGE WIDE-LEG DENIM TROUSER",
      "fit": "LOOSE WIDE-LEG FIT",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["LENGTH", "WAIST", "HIP"],
      "cm": [
        [102, 34, 49],
        [103, 36, 51],
        [104, 38, 53],
        [105, 40, 55]
      ]
    },
    // HOODIES & OUTERWEAR
    {
      "id": "chancellor-400-cropped-full-zip",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR RUCHED FULL-ZIP",
      "fit": "RELAXED CROPPED FIT",
      "copy": "Designed with a relaxed cropped proportion, shaped hood and secure rib-knit boundaries. Compare the flat garment measurements before selecting your size.",
      "pending": false,
      "sizes": ["XS", "S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [46, 48, 38, 59],
        [48, 50, 39.5, 60],
        [50, 52, 41, 61],
        [52, 54, 42.5, 62],
        [54, 56, 44, 63]
      ]
    },
    {
      "id": "chancellor-400-lantern-full-zip",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR LANTERN FULL-ZIP",
      "fit": "RELAXED CROPPED FIT",
      "copy": "Designed with a relaxed cropped proportion, shaped hood and secure rib-knit boundaries. Compare the flat garment measurements before selecting your size.",
      "pending": false,
      "sizes": ["XS", "S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [46, 48, 38, 59],
        [48, 50, 39.5, 60],
        [50, 52, 41, 61],
        [52, 54, 42.5, 62],
        [54, 56, 44, 63]
      ]
    },
    {
      "id": "imperium-380-axis-full-zip",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM AXIS FULL-ZIP",
      "fit": "RELAXED H-LINE FIT",
      "copy": "Designed with a drawstring hood, full-front zip and clean rib-knit cuffs. Compare the flat garment measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [52.5, 66, 47.8, 58.4],
        [54.5, 68, 49.4, 59.2],
        [56.5, 70, 51, 60],
        [58.5, 72, 52.6, 60.8],
        [60.5, 74, 54.2, 61.6],
        [62.5, 76, 55.8, 62.4]
      ]
    },
    {
      "id": "imperium-bastion-full-zip-hoodie",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM BASTION FULL-ZIP",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Designed with a generously scaled hood, full front zip and broad boxy body for the intended BASTION proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [69, 62, 62, 54],
        [71, 63.5, 63.5, 55],
        [73, 65, 65, 56],
        [75, 66.5, 66.5, 57],
        [77, 68, 68, 58]
      ]
    },
    {
      "id": "imperium-bastion-hooded-pullover",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM BASTION HOODED PULLOVER",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Designed with a generously scaled hood, broad straight body and controlled rib-knit boundaries for the intended BASTION proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [69, 62, 62, 54],
        [71, 63.5, 63.5, 55],
        [73, 65, 65, 56],
        [75, 66.5, 66.5, 57],
        [77, 68, 68, 58]
      ]
    },
    {
      "id": "imperium-frame-full-zip-pullover",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FRAME FULL-ZIP",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Designed with a substantial hood, two-way full-zip closure and broad H-line body for the intended structured FRAME proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [72, 60, 65, 55],
        [74, 62, 67, 56],
        [76, 64, 69, 57],
        [78, 66, 71, 58],
        [80, 68, 73, 59]
      ]
    },
    {
      "id": "imperium-frame-hooded-pullover",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FRAME HOODED PULLOVER",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Designed with a substantial hood, broad H-line body and controlled rib-knit boundaries for the intended FRAME proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [72, 59, 65, 55],
        [74, 61, 67, 56],
        [76, 63, 69, 57],
        [78, 65, 71, 58],
        [80, 67, 73, 59]
      ]
    },
    {
      "id": "imperium-360-hoodie",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM HOODIE",
      "fit": "OVERSIZED FIT",
      "copy": "Designed with an oversized silhouette and progressive volume through the body.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [62, 67, 68],
        [64, 69, 70],
        [66, 71, 72],
        [68, 73, 74],
        [70, 75, 76]
      ]
    },
    {
      "id": "imperium-500-hoodie",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM HOODIE",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with a cropped oversized silhouette and heavyweight architectural proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [61, 58.5, 57],
        [63, 60.5, 59],
        [65, 62.5, 61],
        [67, 64.5, 63],
        [69, 66.5, 65]
      ]
    },
    {
      "id": "reserve-350-hoodie",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE HOODIE",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with a cropped oversized silhouette, broad chest and extended shoulders.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [71, 63, 66.5, 59],
        [73, 65, 68, 60],
        [75, 67, 69.5, 61],
        [77, 69, 71, 62],
        [79, 71, 72.5, 63]
      ]
    },
    {
      "id": "imperium-vector-hoodie",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM VECTOR HOODIE",
      "fit": "RELAXED FIT",
      "copy": "Shoulder measurement is not supplied for this raglan construction.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [63, 65, 82],
        [65, 67, 83.5],
        [67, 69, 85],
        [69, 71, 86.5],
        [71, 73, 88]
      ]
    },
    {
      "id": "chancellor-signature-hooded-pullover",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR AXIS PULLOVER",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with deliberate architectural volume.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [68, 64, 66, 56],
        [70, 66, 68, 57],
        [72, 68, 70, 58],
        [74, 70, 72, 59]
      ]
    },
    {
      "id": "chancellor-full-zip-hooded-jacket",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR FULL-ZIP HOODED JACKET",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with broad, controlled boxy proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [60, 62, 56, 63],
        [62, 64, 58, 64],
        [64, 66, 60, 65],
        [66, 68, 62, 66],
        [68, 70, 64, 67]
      ]
    },
    {
      "id": "chancellor-hooded-pullover",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR HOODED PULLOVER",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with broad, controlled boxy proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [60, 62, 56, 63],
        [62, 64, 58, 64],
        [64, 66, 60, 65],
        [66, 68, 62, 66],
        [68, 70, 64, 67]
      ]
    },
    {
      "id": "dexterous-360-waffle-hoodie",
      "category": "outerwear",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE HOODIE",
      "fit": "OVERSIZED FIT",
      "copy": "Designed with an oversized silhouette, dropped shoulders and balanced length for relaxed architectural proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [65, 70, 64, 53],
        [67, 72, 66, 54],
        [69, 74, 68, 55],
        [71, 76, 70, 56],
        [73, 78, 72, 57]
      ]
    },
    {
      "id": "dexterous-360-waffle-cropped-hoodie",
      "category": "outerwear",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE CROPPED HOODIE",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with a cropped boxy body, broad chest and dropped shoulders for deliberate volume and controlled proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [69, 62, 62, 54],
        [71, 63.5, 63.5, 55],
        [73, 65, 65, 56],
        [75, 66.5, 66.5, 57],
        [77, 68, 68, 58]
      ]
    },
    {
      "id": "dexterous-360-waffle-full-zip-jacket",
      "category": "outerwear",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE FULL-ZIP",
      "fit": "CROPPED OVERSIZED FIT",
      "copy": "Designed with a cropped boxy body, broad chest and dropped shoulders, balanced by a full front zip for adaptable proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [69, 62, 62, 54],
        [71, 63.5, 63.5, 55],
        [73, 65, 65, 56],
        [75, 66.5, 66.5, 57],
        [77, 68, 68, 58]
      ]
    },
    {
      "id": "dexterous-archon-waffle-hooded-pullover",
      "category": "outerwear",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS ARCHON WAFFLE HOODED PULLOVER",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Designed with pronounced width, dropped shoulders and a substantial hood for the intended structured proportion.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [69, 62, 62, 54],
        [71, 63.5, 63.5, 55],
        [73, 65, 65, 56],
        [75, 66.5, 66.5, 57],
        [77, 68, 68, 58]
      ]
    },
    {
      "id": "autarch-1000-hooded-pullover",
      "category": "outerwear",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH HOODED PULLOVER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "autarch-750-pullover",
      "category": "outerwear",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH HOODED PULLOVER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "autarch-450-pullover",
      "category": "outerwear",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH HOODED PULLOVER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "autarch-600-hooded-pullover",
      "category": "outerwear",
      "collection": "THE AUTARCH",
      "title": "THE AUTARCH PATINA PULLOVER",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "imperium-360-full-zip",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FULL-ZIP",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "imperium-420-knit-cardigan",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM KNIT CARDIGAN",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "dexterous-women-waffle-full-zip",
      "category": "outerwear",
      "collection": "THE DEXTEROUS",
      "title": "THE DEXTEROUS WAFFLE FULL-ZIP PULLOVER",
      "fit": "SIZE GUIDE",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [51, 58, 40, 65],
        [53, 60, 41, 66],
        [55, 62, 42, 67],
        [57, 64, 43, 68],
        [59, 66, 44, 69]
      ]
    },
    {
      "id": "reserve-crop-pullover",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE CROP PULLOVER",
      "fit": "CROPPED LOOSE FIT",
      "copy": "Chest, length, shoulder and sleeve measurements are taken flat. Compare them with a similar cropped hooded pullover you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [51, 43, 48, 56],
        [53, 44.5, 50, 57],
        [55, 46, 52, 58],
        [57, 47.5, 54, 59]
      ]
    },
    {
      "id": "reserve-crop-full-zip",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE CROP FULL-ZIP",
      "fit": "CROPPED LOOSE FIT",
      "copy": "Chest, length, shoulder and sleeve measurements are taken flat. Compare them with a similar cropped full-zip hooded garment you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [45, 46, 46, 63],
        [47, 47.5, 48, 64],
        [49, 49, 50, 65],
        [51, 50.5, 52, 66]
      ]
    },
    {
      "id": "reserve-390-hooded-pullover",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE HOODED PULLOVER",
      "fit": "OVERSIZED BOXY FIT",
      "copy": "Chest is a flat width. Compare the chest, body length, shoulder and sleeve measurements with a similar hooded pullover you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [68, 63, 62, 53],
        [70, 65, 64, 54],
        [72, 67, 66, 55],
        [74, 69, 68, 56],
        [76, 71, 70, 57]
      ]
    },
    {
      "id": "imperium-350-relic-pullover",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM RELIC PULLOVER",
      "fit": "LOOSE FIT",
      "copy": "Compare the flat chest, body length, shoulder and sleeve measurements with a similar full-zip hoodie you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [51, 59, 40, 65],
        [53, 61, 41.5, 66],
        [55, 63, 43, 67],
        [57, 65, 44.5, 68],
        [59, 67, 46, 69]
      ]
    },
    {
      "id": "imperium-420-pleated-hoodie",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM PLEATED HOODED PULLOVER",
      "fit": "OVERSIZED FIT",
      "copy": "Compare the flat chest, body length, shoulder and sleeve measurements with a similar hooded pullover you own.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [65, 68, 63, 55],
        [67, 70, 65, 56],
        [69, 72, 67, 57],
        [71, 74, 69, 58]
      ]
    },
    {
      "id": "chancellor-cinched-full-zip",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR CINCHED FULL-ZIP",
      "fit": "SIZE SPECIFICATION PENDING",
      "copy": "Verified production measurements are pending.",
      "pending": true,
      "sizes": [],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": []
    },
    {
      "id": "sovereign-full-zip-jacket",
      "category": "outerwear",
      "collection": "THE SOVEREIGN",
      "title": "THE SOVEREIGN FULL-ZIP JACKET",
      "fit": "SCULPTED CROPPED FIT",
      "copy": "Compare the flat chest, length, shoulder and sleeve measurements with a fitted technical jacket you own before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [39, 44.5, 33, 64],
        [41, 45.5, 34, 65],
        [43, 46.5, 35, 66],
        [45, 47.5, 36, 67]
      ]
    },
    {
      "id": "imperium-full-zip-jacket",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM FULL-ZIP JACKET",
      "fit": "LOOSE RAGLAN FIT",
      "copy": "Designed with raglan sleeves. A separate shoulder measurement is not provided for this construction. Compare the flat chest, length and sleeve measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [52.5, 65, 72.5],
        [54.5, 67, 74],
        [56.5, 69, 75.5],
        [58.5, 71, 77],
        [60.5, 73, 78.5],
        [62.5, 75, 80]
      ]
    },
    {
      "id": "imperium-apex-full-zip-jacket",
      "category": "outerwear",
      "collection": "THE IMPERIUM",
      "title": "THE IMPERIUM APEX FULL-ZIP JACKET",
      "fit": "LOOSE RAGLAN FIT",
      "copy": "Designed with raglan sleeves. A separate shoulder measurement is not provided for this construction. Compare the flat chest, length and sleeve measurements before selecting your size.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SLEEVE"],
      "cm": [
        [52.5, 65, 72.5],
        [54.5, 67, 74],
        [56.5, 69, 75.5],
        [58.5, 71, 77],
        [60.5, 73, 78.5],
        [62.5, 75, 80]
      ]
    },
    {
      "id": "reserve-420-hooded-pullover",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE HOODED PULLOVER",
      "fit": "RELAXED OVERSIZED FIT",
      "copy": "Verified production measurements provide chest, body length and shoulder. Sleeve length is not included in this garment specification.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER"],
      "cm": [
        [57, 67, 55],
        [59, 69, 57],
        [61, 71, 59],
        [63, 73, 61],
        [65, 75, 63],
        [67, 77, 65]
      ]
    },
    {
      "id": "reserve-420-full-zip-hooded-pullover",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE FULL-ZIP HOODED PULLOVER",
      "fit": "LOOSE OVERSIZED FIT",
      "copy": "Verified production measurements provide chest, body length and shoulder. Sleeve length is not included in this garment specification.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL", "3XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER"],
      "cm": [
        [57, 67, 55],
        [59, 69, 57],
        [61, 71, 59],
        [63, 73, 61],
        [65, 75, 63],
        [67, 77, 65]
      ]
    },
    {
      "id": "reserve-420-raw-edge-full-zip",
      "category": "outerwear",
      "collection": "THE RESERVE",
      "title": "THE RESERVE RAW EDGE FULL-ZIP",
      "fit": "OVERSIZED CROPPED FIT",
      "copy": "Verified production measurements provide chest, body length and shoulder. Sleeve length is not included in this garment specification.",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER"],
      "cm": [
        [62, 62, 61],
        [64, 64, 63],
        [66, 66, 65],
        [68, 68, 67],
        [70, 70, 69]
      ]
    },
    {
      "id": "chancellor-cropped-pullover",
      "category": "outerwear",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR CROPPED PULLOVER",
      "fit": "LOOSE CROPPED FIT",
      "copy": "",
      "pending": false,
      "sizes": ["S", "M", "L", "XL", "2XL"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [58, 46, 54, 57],
        [60, 48, 56, 59],
        [62, 50, 58, 61],
        [64, 52, 60, 63],
        [66, 54, 62, 65]
      ]
    },
    // DRESSES
    {
      "id": "chancellor-stripe-polo-dress",
      "category": "dresses",
      "collection": "THE CHANCELLOR",
      "title": "THE CHANCELLOR STRIPE POLO DRESS",
      "fit": "LOOSE H-LINE FIT",
      "copy": "Compare the flat chest, full body length, shoulder and sleeve measurements with a similar polo dress you own.",
      "pending": false,
      "sizes": ["S", "M", "L"],
      "metrics": ["CHEST", "LENGTH", "SHOULDER", "SLEEVE"],
      "cm": [
        [50, 80, 44, 25],
        [52, 82, 46, 26],
        [54, 84, 48, 27]
      ]
    },
  ];

  const aliases = {
    "chancellor-signature-pullover": "chancellor-signature-hooded-pullover",
    "imperium-360-hooded-pullover": "imperium-360-hoodie",
    "imperium-360-straight-leg-trouser": "imperium-360-trouser",
    "chancellor-350-t-shirt": "chancellor-350",
    "chancellor-355-sweatshirt": "chancellor-355-crewneck",
    "chancellor-320-collared-sweatshirt": "chancellor-320-collared-pullover",
    "chancellor-axis-pullover": "chancellor-signature-hooded-pullover",
    "chancellor-axis-pullover-hoodie": "chancellor-signature-hooded-pullover",
    "chancellor-lantern-full-zip": "chancellor-400-lantern-full-zip",
    "chancellor-lantern-full-zip-mmxxvi-signature": "chancellor-400-lantern-full-zip",
    "dexterous-340-waffle-knit-t-shirt": "dexterous-340",
    "dexterous-340-waffle-straight-leg-trouser": "dexterous-waffle-straight-leg-trouser",
    "dexterous-waffle-frame-t-shirt": "dexterous-350-waffle-frame-t-shirt",
    "dexterous-waffle-bermuda": "dexterous-350-waffle-bermuda",
    "dexterous-360-full-zip-hoodie": "dexterous-360-waffle-full-zip-jacket",
    "governor-engineered-wide-leg-denim-trouser": "governor-400-wide-leg-denim-trouser",
    "imperium-frame-full-zip-hoodie": "imperium-frame-full-zip-pullover",
    "imperium-axis-full-zip": "imperium-380-axis-full-zip",
    "imperium-relic-trouser": "imperium-350-relic-wide-leg-trouser",
    "imperium-350-relic-trouser": "imperium-350-relic-wide-leg-trouser",
    "imperium-750-quarterzip": "imperium-750-quarter-zip",
    "sovereign-sculpture-square-neck": "sovereign-sculpt-square-neck",
    "sovereign-sculpture-high-rise-bermuda": "sovereign-sculpt-high-rise-bermuda",
    "regent-400-sweatshirt": "regent-400-crewneck",
    "regent-420-straight-leg-trouser": "regent-420-trouser",
    "reserve-350-bermuda": "reserve-355-bermuda",
    "reserve-350-pullover": "reserve-350-hoodie",
    "reserve-350-t-shirt": "reserve-350",
    "reserve-360-sweatshirt": "reserve-360-crewneck",
    "reserve-400-t-shirt": "reserve-400"
  };


  // Validate the WHOLE snapshot before changing the running registry.
  const objectRecord = value => value !== null && typeof value === 'object' && !Array.isArray(value);
  const fail = message => { throw new Error('[FEROBRILL inline charts] ' + message); };
  const validId = value => typeof value === 'string' && /^[A-Za-z0-9][A-Za-z0-9-]*$/.test(value)
    && !['__proto__', 'prototype', 'constructor'].includes(value);
  const suppliedText = value => typeof value === 'string' && value.trim().length > 0;
  const ids = new Set();
  const allowedMetrics = new Set(['CHEST', 'LENGTH', 'SHOULDER', 'SLEEVE', 'WAIST', 'HIP', 'BUST', 'UNDERBUST']);
  let pendingCount = 0, sizeRows = 0, numericCells = 0, unsuppliedCells = 0;

  if (records.length !== source.totalRecords) fail('Incomplete record list. Original data was not changed.');
  for (const record of records) {
    if (!objectRecord(record) || !validId(record.id) || ids.has(record.id)) fail('Invalid or duplicate guide ID.');
    ids.add(record.id);
    if (!suppliedText(record.title) || !suppliedText(record.collection) || !suppliedText(record.fit)
        || typeof record.copy !== 'string' || typeof record.pending !== 'boolean'
        || !Object.prototype.hasOwnProperty.call(source.categories, record.category)) fail('Invalid record metadata: ' + record.id);
    if (!Array.isArray(record.metrics) || !record.metrics.length
        || new Set(record.metrics).size !== record.metrics.length
        || record.metrics.some(metric => !allowedMetrics.has(metric))) fail('Invalid measurement headings: ' + record.id);
    if (!Array.isArray(record.sizes) || !Array.isArray(record.cm)
        || record.sizes.length !== record.cm.length
        || new Set(record.sizes).size !== record.sizes.length
        || record.sizes.some(size => !suppliedText(size))) fail('Invalid size rows: ' + record.id);
    if (record.pending) {
      pendingCount += 1;
      if (record.sizes.length || record.cm.length) fail('Pending guide contains invented rows: ' + record.id);
    } else if (!record.sizes.length) fail('Populated guide has no measurements: ' + record.id);
    sizeRows += record.sizes.length;
    for (const row of record.cm) {
      if (!Array.isArray(row) || row.length !== record.metrics.length) fail('Column mismatch: ' + record.id);
      for (const value of row) {
        if (value === null) { unsuppliedCells += 1; continue; }
        if (typeof value !== 'number' || !Number.isFinite(value) || value <= 0) fail('Invalid dimension: ' + record.id);
        numericCells += 1;
      }
    }
  }
  if (pendingCount !== source.pendingRecords || records.length-pendingCount !== source.populatedRecords
      || sizeRows !== source.sizeRows || numericCells !== source.numericMeasurementCells
      || unsuppliedCells !== source.unsuppliedMeasurementCells) fail('Snapshot totals do not match.');
  for (const [category, expected] of Object.entries(source.categories)) {
    const group = records.filter(record => record.category === category);
    if (group.length !== expected.total || group.filter(record => record.pending).length !== expected.pending)
      fail('Incomplete category: ' + category);
  }
  if (Object.keys(aliases).length !== source.aliasCount) fail('Incomplete alias list.');
  for (const [alias, target] of Object.entries(aliases)) {
    if (!validId(alias) || ids.has(alias) || !ids.has(target)) fail('Invalid alias: ' + alias);
  }

  const previous = window.FerobrillMeasurements;
  if (previous !== undefined && !objectRecord(previous)) fail('Existing registry is not an object; no data changed.');
  if (previous === undefined) {
    console.warn('[FEROBRILL inline charts] Base registry was not detected. Append this patch after the original fb-measurements.js code.');
  }
  const next = { ...(previous || {}) };
  for (const record of records) {
    const existing = objectRecord(next[record.id]) ? next[record.id] : {};
    next[record.id] = {
      ...existing,
      ...record,
      sizes: [...record.sizes],
      metrics: [...record.metrics],
      cm: record.cm.map(row => [...row])
    };
  }
  // Only the Master Guide's explicit aliases are installed. Never infer a
  // chart from a similar garment title, a shared collection, or its weight.
  for (const [alias, target] of Object.entries(aliases)) next[alias] = next[target];

  window.FerobrillMeasurements = next;
  window.FerobrillInlineChartDataStatus = {
    ...source,
    registeredCanonicalGuideIds: [...ids],
    pendingGuideIds: records.filter(record => record.pending).map(record => record.id),
    aliases: { ...aliases },
    validated: true,
    mode: 'static-master-snapshot'
  };
  // Deliberately do not touch window.FerobrillFormGuides, variant selection,
  // product content, measurement markup, CSS, or any page/popup settings.
})();
/* FEROBRILL_COMPLETE_INLINE_SIZE_CHART_DATA_PATCH - END */


/* FEROBRILL_CHANCELLOR_320_FLARE_GUIDE_ALIAS_PATCH - BEGIN
 * Keeps coordinate-form ID synchronized with the populated canonical flare trouser chart.
 */
(() => {
  const source = window.FerobrillMeasurements?.["chancellor-flare-trouser"];
  if (!source || source.pending || !source.sizes?.length || !source.cm?.length) return;

  window.FerobrillMeasurements["chancellor-320-flare-trouser"] = {
    ...source,
    id: "chancellor-320-flare-trouser",
    title: "THE CHANCELLOR FLARE TROUSER",
    pending: false,
    sizes: [...source.sizes],
    metrics: [...source.metrics],
    cm: source.cm.map(row => [...row])
  };
})();
/* FEROBRILL_CHANCELLOR_320_FLARE_GUIDE_ALIAS_PATCH - END */


/* FEROBRILL_IMPERIUM_VAULT_412_SIZE_GUIDES - BEGIN */
(() => {
  const registry = window.FerobrillMeasurements;
  if (!registry || typeof registry !== 'object') return;

  registry["imperium-412-vault-full-zip-pullover"] = {
    id: "imperium-412-vault-full-zip-pullover",
    category: "sweatshirts",
    collection: "THE IMPERIUM",
    title: "THE IMPERIUM VAULT FULL ZIP PULLOVER",
    fit: "SHORT FITTED SILHOUETTE",
    intro: "A short fitted body, regular shoulder line and long bell sleeves establish the VAULT full-zip silhouette with substantial 412 GSM structure.",
    copy: "Measurements are taken flat. Compare body length, shoulder, chest and sleeve measurements with a fitted full-zip garment you own.",
    pos: 3,
    pending: false,
    sizes: ["XS","S","M","L","XL"],
    metrics: ["LENGTH","SHOULDER","CHEST","SLEEVE"],
    cm: [[46,36,37,61],[48,38,39,62],[50,40,41,63],[52,42,43,64],[54,44,45,65]]
  };

  registry["imperium-412-vault-pleated-trouser"] = {
    id: "imperium-412-vault-pleated-trouser",
    category: "bottoms",
    collection: "THE IMPERIUM",
    title: "THE IMPERIUM VAULT PLEATED TROUSER",
    fit: "FLARED TROUSER FIT",
    intro: "A broad waistband, measured hip and extended flared leg establish the VAULT trouser silhouette with controlled 412 GSM drape.",
    copy: "Waist and hip measurements are taken flat. Compare body length, waist and hip measurements with a similar trouser you own.",
    pos: 3,
    pending: false,
    sizes: ["XS","S","M","L","XL"],
    metrics: ["LENGTH","WAIST","HIP"],
    cm: [[100,31,45],[102,33,47],[104,35,49],[106,37,51],[108,39,53]]
  };
})();
 /* FEROBRILL_IMPERIUM_VAULT_412_SIZE_GUIDES - END */
